var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoImageEn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 658,
    height: 677,
    viewBox: "0 0 658 677",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27566",
    "data-name": "Rectangle 27566",
    width: 203.81,
    height: 132.087,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27570",
    "data-name": "Rectangle 27570",
    width: 123.998,
    height: 68.15,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27580",
    "data-name": "Rectangle 27580",
    width: 12,
    height: 11.441,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27581",
    "data-name": "Rectangle 27581",
    width: 50.52,
    height: 90.09,
    transform: "translate(0 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27565",
    "data-name": "Rectangle 27565",
    width: 36.012,
    height: 106.43,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27563",
    "data-name": "Rectangle 27563",
    width: 31.659,
    height: 2.851,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27586",
    "data-name": "Rectangle 27586",
    width: 51.465,
    height: 111.394,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27589",
    "data-name": "Rectangle 27589",
    width: 56.254,
    height: 113.857,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27560",
    "data-name": "Rectangle 27560",
    width: 36.852,
    height: 108.912,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27558",
    "data-name": "Rectangle 27558",
    width: 32.398,
    height: 2.918,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27592",
    "data-name": "Rectangle 27592",
    width: 64.352,
    height: 116.311,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_71961",
    "data-name": "Group 71961",
    transform: "translate(20341 -4337)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7606",
    "data-name": "Path 7606",
    d: "M2.666,0H655.333C656.805,0,658,2.279,658,5.09V671.91c0,2.811-1.194,5.09-2.666,5.09H2.666C1.194,677,0,674.721,0,671.91V5.09C0,2.279,1.194,0,2.666,0Z",
    transform: "translate(-20341 4337)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("text", {
    id: "How_it_works_",
    "data-name": "How it works?",
    transform: "translate(-20094 4403)",
    fill: "#130f30",
    fontSize: 22,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "How it works?")), /*#__PURE__*/React.createElement("text", {
    id: "Fill_out_the_checklist",
    "data-name": "Fill out the checklist",
    transform: "translate(-20201.219 4476.318)",
    fill: "#130f30",
    fontSize: 14,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Fill out the checklist")), /*#__PURE__*/React.createElement("path", {
    id: "Path_7825",
    "data-name": "Path 7825",
    d: "M157.074,407.213l-.032,0c-.669-.062-1.35-.133-2.023-.208-.279-.032-.488-.392-.467-.8s.266-.72.544-.689c.669.076,1.345.146,2.01.207.279.026.492.381.474.794-.017.4-.24.7-.505.7m-5.038-.594a.343.343,0,0,1-.049,0c-.67-.1-1.349-.2-2.018-.307-.278-.046-.479-.415-.449-.826s.281-.705.559-.662c.665.108,1.339.211,2,.306.278.039.482.405.455.816-.025.387-.246.676-.5.676m-5.023-.839a.308.308,0,0,1-.065-.006c-.668-.127-1.344-.264-2.01-.4-.277-.059-.47-.438-.43-.847s.3-.7.573-.635c.662.139,1.334.274,2,.4.277.053.473.429.437.838-.033.377-.251.652-.5.652m-5-1.079a.36.36,0,0,1-.082-.01c-.664-.159-1.337-.327-2-.5a.775.775,0,0,1-.411-.866c.048-.408.311-.678.586-.608.659.171,1.328.338,1.988.5a.768.768,0,0,1,.419.859c-.04.368-.255.628-.5.628m-4.978-1.316a.34.34,0,0,1-.1-.014c-.658-.19-1.327-.39-1.989-.594a.8.8,0,0,1-.393-.886c.057-.4.326-.664.6-.58.658.2,1.323.4,1.976.59a.788.788,0,0,1,.4.878c-.047.357-.259.6-.5.6m-4.948-1.548a.35.35,0,0,1-.113-.019c-.657-.221-1.321-.453-1.976-.686a.817.817,0,0,1-.373-.9c.066-.4.34-.648.611-.552.651.232,1.311.462,1.963.682a.807.807,0,0,1,.381.9c-.053.347-.262.582-.493.582m-4.913-1.779a.351.351,0,0,1-.128-.025c-.654-.253-1.313-.514-1.961-.777a.836.836,0,0,1-.354-.92c.074-.4.353-.633.623-.524.643.262,1.3.522,1.948.773a.828.828,0,0,1,.362.914c-.06.336-.265.559-.49.559m-4.874-2.005a.354.354,0,0,1-.143-.031c-.646-.281-1.3-.574-1.944-.867a.854.854,0,0,1-.334-.936c.082-.395.366-.615.633-.494.639.291,1.289.582,1.932.862a.846.846,0,0,1,.342.93c-.065.326-.267.537-.486.537m-4.83-2.229a.357.357,0,0,1-.158-.038c-.638-.31-1.285-.631-1.925-.956a.872.872,0,0,1-.315-.951c.091-.391.379-.6.644-.465.636.322,1.279.643,1.913.951a.866.866,0,0,1,.323.945c-.07.314-.268.514-.481.514m-4.782-2.449a.366.366,0,0,1-.173-.046c-.633-.341-1.274-.692-1.9-1.045a.888.888,0,0,1-.295-.964c.1-.387.391-.581.653-.435.627.35,1.263.7,1.893,1.038a.882.882,0,0,1,.3.959c-.075.3-.269.493-.476.493m-4.728-2.669a.369.369,0,0,1-.188-.054c-.626-.37-1.259-.75-1.881-1.132a.906.906,0,0,1-.274-.978c.107-.381.4-.562.662-.4.619.379,1.248.757,1.87,1.124a.9.9,0,0,1,.283.973c-.079.293-.269.471-.47.471m-4.671-2.886a.37.37,0,0,1-.2-.063c-.618-.4-1.242-.808-1.857-1.219a.92.92,0,0,1-.253-.99c.115-.377.415-.544.67-.373.61.407,1.231.814,1.845,1.211a.915.915,0,0,1,.261.985c-.083.281-.269.449-.464.449m-4.608-3.1a.375.375,0,0,1-.217-.072c-.609-.427-1.225-.866-1.83-1.3a.937.937,0,0,1-.232-1c.123-.372.427-.525.678-.343.6.435,1.214.871,1.819,1.3a.931.931,0,0,1,.241,1c-.087.269-.268.427-.458.427m-4.54-3.314a.379.379,0,0,1-.231-.083c-.6-.457-1.209-.924-1.8-1.389a.952.952,0,0,1-.21-1.012c.131-.365.438-.5.685-.31.59.462,1.192.926,1.79,1.38A.946.946,0,0,1,94.589,381a.523.523,0,0,1-.451.406m-4.467-3.526a.382.382,0,0,1-.245-.094c-.588-.482-1.184-.977-1.771-1.474a.965.965,0,0,1-.188-1.021c.139-.359.449-.483.691-.278.584.493,1.175.986,1.76,1.465a.96.96,0,0,1,.2,1.018.514.514,0,0,1-.444.385M432,375h-.018c-.679-.036-1.361-.077-2.027-.123-.279-.019-.5-.369-.482-.782s.25-.731.53-.713c.661.046,1.34.087,2.015.122.28.014.5.361.488.775s-.234.722-.506.722m-5.048-.368-.033,0c-.671-.063-1.351-.133-2.021-.207-.279-.031-.488-.39-.467-.8s.266-.719.543-.69c.666.074,1.342.143,2.01.206.279.026.491.381.474.794-.017.4-.24.7-.505.7m-341.67-.491a.388.388,0,0,1-.26-.106c-.584-.515-1.168-1.04-1.738-1.558a.975.975,0,0,1-.166-1.03c.146-.352.459-.462.7-.245.566.515,1.147,1.035,1.726,1.548a.971.971,0,0,1,.175,1.026.506.506,0,0,1-.435.364m336.634-.09a.325.325,0,0,1-.048,0c-.67-.092-1.349-.191-2.016-.3-.278-.043-.48-.412-.451-.823s.279-.709.557-.666c.663.1,1.337.2,2,.294.278.039.483.4.457.815-.025.388-.245.679-.5.679m-5.021-.806a.349.349,0,0,1-.063-.006c-.673-.124-1.349-.255-2.009-.389-.277-.056-.471-.434-.433-.844s.293-.7.571-.639c.656.133,1.327.263,2,.387.278.051.475.425.44.835-.032.379-.25.656-.5.656m-5-1.042a.335.335,0,0,1-.079-.01c-.67-.157-1.343-.321-2-.487a.774.774,0,0,1-.413-.865c.047-.408.31-.68.585-.61.652.166,1.32.329,1.985.484a.765.765,0,0,1,.421.857c-.039.368-.255.631-.5.631m-4.973-1.293a.34.34,0,0,1-.1-.014c-.663-.19-1.331-.389-1.986-.591a.8.8,0,0,1-.392-.886c.057-.4.326-.663.6-.579.65.2,1.313.4,1.971.587a.787.787,0,0,1,.4.878c-.047.358-.259.606-.5.606M80.978,370.2a.4.4,0,0,1-.273-.119c-.567-.539-1.141-1.091-1.7-1.641a.988.988,0,0,1-.143-1.038c.155-.344.469-.438.7-.211.559.546,1.128,1.095,1.692,1.63a.983.983,0,0,1,.152,1.034.5.5,0,0,1-.427.343m321.007-.841a.346.346,0,0,1-.115-.019c-.656-.226-1.319-.462-1.97-.7a.82.82,0,0,1-.369-.907c.067-.4.342-.646.614-.545.646.237,1.3.471,1.955.7a.809.809,0,0,1,.378.9c-.054.345-.262.578-.493.578m-4.894-1.83a.353.353,0,0,1-.135-.027c-.653-.265-1.31-.54-1.95-.816a.845.845,0,0,1-.344-.928c.078-.4.36-.625.628-.508.635.274,1.286.546,1.934.809a.834.834,0,0,1,.354.919c-.062.332-.266.551-.488.551m-320.327-1.48a.4.4,0,0,1-.287-.133c-.554-.565-1.115-1.145-1.665-1.724a1,1,0,0,1-.12-1.044c.162-.336.479-.416.707-.176.547.574,1.1,1.151,1.654,1.712a.994.994,0,0,1,.128,1.042.487.487,0,0,1-.417.323m315.487-.641a.348.348,0,0,1-.154-.036c-.642-.3-1.29-.618-1.926-.936a.869.869,0,0,1-.317-.948c.089-.392.377-.6.642-.469.631.315,1.274.627,1.909.928a.858.858,0,0,1,.328.94c-.069.318-.268.521-.482.521m-4.775-2.425a.366.366,0,0,1-.175-.046c-.636-.347-1.275-.7-1.9-1.062a.894.894,0,0,1-.288-.969c.1-.385.4-.575.656-.426.616.355,1.249.71,1.88,1.053a.885.885,0,0,1,.3.961c-.075.3-.269.489-.475.489M72.644,361.69a.411.411,0,0,1-.3-.147c-.543-.6-1.09-1.2-1.625-1.807a1,1,0,0,1-.1-1.049c.17-.328.488-.392.711-.141.531.6,1.074,1.2,1.614,1.794a1,1,0,0,1,.105,1.047.479.479,0,0,1-.407.3m310.133-1.45a.371.371,0,0,1-.2-.059c-.621-.388-1.248-.789-1.862-1.194a.919.919,0,0,1-.256-.988c.114-.377.414-.548.669-.38.608.4,1.228.8,1.844,1.182a.909.909,0,0,1,.269.981c-.081.286-.269.458-.467.458m-4.6-3.071a.377.377,0,0,1-.22-.075c-.609-.433-1.221-.88-1.821-1.329a.944.944,0,0,1-.223-1.006c.126-.368.431-.516.681-.329.593.444,1.2.887,1.8,1.316a.934.934,0,0,1,.237,1c-.088.268-.268.424-.457.424m-309.545-.039a.415.415,0,0,1-.315-.163c-.529-.621-1.061-1.257-1.582-1.887a1.01,1.01,0,0,1-.071-1.054.406.406,0,0,1,.713-.1c.518.627,1.046,1.257,1.571,1.875a1.007,1.007,0,0,1,.081,1.051.469.469,0,0,1-.4.282m305.05-3.371a.381.381,0,0,1-.242-.092c-.595-.48-1.191-.974-1.773-1.469a.964.964,0,0,1-.187-1.022c.139-.358.449-.482.691-.276.576.489,1.166.978,1.754,1.453a.957.957,0,0,1,.2,1.016.516.516,0,0,1-.445.389M64.72,352.367a.422.422,0,0,1-.329-.179c-.512-.647-1.029-1.309-1.536-1.968a1.015,1.015,0,0,1-.046-1.056.4.4,0,0,1,.715-.068c.5.656,1.018,1.313,1.526,1.955A1.014,1.014,0,0,1,65.1,352.1a.461.461,0,0,1-.385.262M369.309,350a.4.4,0,0,1-.266-.113c-.577-.529-1.155-1.071-1.717-1.61a.986.986,0,0,1-.149-1.036c.152-.346.467-.445.7-.219.556.534,1.128,1.07,1.7,1.593a.977.977,0,0,1,.164,1.03.5.5,0,0,1-.431.355m-308.38-2.6a.43.43,0,0,1-.342-.2c-.5-.674-1-1.363-1.488-2.047a1.016,1.016,0,0,1-.02-1.058.4.4,0,0,1,.716-.031c.487.68.984,1.363,1.477,2.033a1.016,1.016,0,0,1,.031,1.057.453.453,0,0,1-.374.243m304.156-1.515a.4.4,0,0,1-.29-.136c-.555-.574-1.112-1.164-1.655-1.753a1,1,0,0,1-.108-1.046c.165-.333.483-.4.708-.16.536.582,1.087,1.166,1.636,1.733a1,1,0,0,1,.125,1.043.487.487,0,0,1-.415.319M57.26,342.245a.441.441,0,0,1-.356-.216c-.479-.7-.963-1.414-1.436-2.126a1.018,1.018,0,0,1,.005-1.059.4.4,0,0,1,.717.009c.471.707.951,1.417,1.426,2.111a1.018,1.018,0,0,1,0,1.059.444.444,0,0,1-.36.223m303.764-.819a.416.416,0,0,1-.314-.161c-.532-.622-1.065-1.26-1.584-1.9a1.01,1.01,0,0,1-.066-1.054.406.406,0,0,1,.713-.1c.512.628,1.039,1.258,1.565,1.873a1.007,1.007,0,0,1,.083,1.051.47.47,0,0,1-.4.284m-307.3-4.534a.448.448,0,0,1-.369-.236c-.461-.725-.926-1.465-1.382-2.2A1.016,1.016,0,0,1,52,333.4a.4.4,0,0,1,.715.047c.452.732.914,1.468,1.372,2.187a1.017,1.017,0,0,1-.022,1.058.434.434,0,0,1-.347.2m303.422-.278a.427.427,0,0,1-.337-.19c-.505-.665-1.012-1.35-1.506-2.033a1.019,1.019,0,0,1-.024-1.059.4.4,0,0,1,.716-.035c.488.676.989,1.351,1.488,2.009a1.015,1.015,0,0,1,.041,1.056.456.456,0,0,1-.378.25M50.016,331.97c-.178,0-.356,0-.534-.006-.28-.006-.5-.346-.5-.759s.23-.737.506-.737H49.5l.076,0c-.322-.55-.643-1.1-.958-1.654a1.011,1.011,0,0,1,.06-1.055.405.405,0,0,1,.714.088c.431.753.873,1.513,1.314,2.261a.925.925,0,0,1,.116.35c.225-.008.45-.019.672-.033.277-.017.516.3.528.715s-.2.762-.484.78c-.5.032-1.013.048-1.52.048m-3.556-.262a.358.358,0,0,1-.051,0c-.675-.1-1.36-.228-2.035-.382a.762.762,0,0,1-.423-.854c.042-.409.3-.688.578-.625.658.15,1.324.275,1.981.372.278.041.482.408.454.819-.026.386-.247.675-.5.675m8.077-.182c-.249,0-.467-.273-.5-.648-.038-.409.157-.787.434-.842.661-.133,1.321-.3,1.963-.488.274-.082.542.18.6.586a.791.791,0,0,1-.4.882c-.663.2-1.345.367-2.028.5a.334.334,0,0,1-.069.007m298.928-.061a.442.442,0,0,1-.359-.221c-.478-.71-.956-1.439-1.422-2.167a1.017,1.017,0,0,1,.02-1.058.4.4,0,0,1,.717.029c.46.719.933,1.439,1.4,2.14a1.018,1.018,0,0,1,0,1.059.442.442,0,0,1-.357.218m-311.993-1a.359.359,0,0,1-.118-.02c-.661-.232-1.328-.5-1.982-.78a.846.846,0,0,1-.343-.93c.079-.4.361-.623.629-.506.637.278,1.287.533,1.93.759a.814.814,0,0,1,.376.9c-.056.343-.264.575-.493.575m18-.543c-.216,0-.416-.206-.483-.527a.853.853,0,0,1,.334-.936c.635-.291,1.266-.617,1.876-.969.26-.151.555.039.656.425a.894.894,0,0,1-.287.969c-.633.365-1.287.7-1.945,1a.351.351,0,0,1-.15.034m-22.834-1.667a.356.356,0,0,1-.181-.05c-.637-.361-1.275-.752-1.9-1.162a.919.919,0,0,1-.256-.989c.114-.377.414-.546.669-.378.6.4,1.225.78,1.845,1.132a.892.892,0,0,1,.292.967c-.078.3-.27.48-.473.48m27.505-1.184a.521.521,0,0,1-.448-.4.952.952,0,0,1,.211-1.012c.586-.457,1.164-.952,1.717-1.47.236-.221.549-.118.7.231a.981.981,0,0,1-.157,1.033c-.575.54-1.176,1.054-1.786,1.53a.381.381,0,0,1-.236.086M350.006,326a.458.458,0,0,1-.381-.255c-.444-.748-.89-1.516-1.322-2.283a1.013,1.013,0,0,1,.064-1.055.406.406,0,0,1,.714.1c.427.757.866,1.515,1.306,2.254a1.014,1.014,0,0,1-.047,1.056.426.426,0,0,1-.334.187m-302.938-.376a.467.467,0,0,1-.395-.278c-.424-.776-.849-1.567-1.264-2.351a1.006,1.006,0,0,1,.087-1.051c.22-.254.538-.2.711.129.412.778.834,1.563,1.254,2.333a1.008,1.008,0,0,1-.076,1.052.416.416,0,0,1-.317.166m-15.017-.509a.385.385,0,0,1-.244-.092c-.6-.488-1.2-1.005-1.771-1.538a.98.98,0,0,1-.16-1.032c.149-.35.461-.456.7-.236.558.517,1.137,1.021,1.721,1.5a.959.959,0,0,1,.2,1.017.516.516,0,0,1-.444.387m36.3-2.165a.466.466,0,0,1-.391-.273,1.011,1.011,0,0,1,.07-1.054c.51-.618,1.007-1.275,1.479-1.951a.4.4,0,0,1,.717.015,1.019,1.019,0,0,1-.01,1.059c-.492.705-1.011,1.39-1.542,2.034a.419.419,0,0,1-.321.17m-40.548-1.891a.408.408,0,0,1-.3-.148c-.54-.592-1.083-1.212-1.615-1.844a1.009,1.009,0,0,1-.077-1.052.407.407,0,0,1,.712-.114c.522.62,1.055,1.229,1.584,1.81a1,1,0,0,1,.1,1.047.478.478,0,0,1-.407.3m318.987-.828a.473.473,0,0,1-.4-.291c-.413-.791-.824-1.6-1.223-2.407a1,1,0,0,1,.11-1.046c.226-.244.543-.171.708.163.394.795.8,1.594,1.208,2.376a1,1,0,0,1-.092,1.05.413.413,0,0,1-.309.155m-302.826-.515a.479.479,0,0,1-.407-.3c-.4-.8-.806-1.615-1.2-2.423a1,1,0,0,1,.115-1.044c.227-.242.543-.166.707.17.39.8.791,1.61,1.191,2.4a1,1,0,0,1-.1,1.047.409.409,0,0,1-.3.148m27.943-2.07a.419.419,0,0,1-.319-.167,1.011,1.011,0,0,1-.075-1.053c.413-.753.813-1.542,1.189-2.345.159-.34.474-.426.7-.191a.992.992,0,0,1,.129,1.041c-.39.835-.805,1.655-1.235,2.438a.467.467,0,0,1-.394.278m-48.016-1.32a.429.429,0,0,1-.338-.191c-.5-.664-1-1.354-1.495-2.051a1.017,1.017,0,0,1-.014-1.058.4.4,0,0,1,.717-.021c.482.685.977,1.363,1.468,2.016a1.014,1.014,0,0,1,.039,1.057.455.455,0,0,1-.377.249m319.941-2.152a.49.49,0,0,1-.421-.33c-.377-.825-.752-1.67-1.115-2.51a.981.981,0,0,1,.154-1.034c.236-.222.549-.121.7.228.359.829.73,1.663,1.1,2.479a.989.989,0,0,1-.137,1.038.4.4,0,0,1-.283.128m-302.808-.543a.488.488,0,0,1-.419-.326c-.382-.825-.763-1.663-1.134-2.492a.986.986,0,0,1,.144-1.037c.234-.228.548-.133.7.212.368.823.746,1.655,1.125,2.473a.991.991,0,0,1-.132,1.04.4.4,0,0,1-.285.13m33.674-2.2a.385.385,0,0,1-.239-.089.952.952,0,0,1-.207-1.013c.309-.853.6-1.739.877-2.636.115-.377.415-.545.67-.376a.921.921,0,0,1,.255.989c-.283.929-.588,1.848-.909,2.73a.519.519,0,0,1-.447.395M20.276,311.1a.448.448,0,0,1-.369-.235c-.462-.723-.925-1.471-1.375-2.223a1.014,1.014,0,0,1,.044-1.056.4.4,0,0,1,.715.064c.444.74.9,1.477,1.354,2.189a1.017,1.017,0,0,1-.021,1.058.433.433,0,0,1-.347.2m320.866-3.246a.507.507,0,0,1-.437-.369c-.341-.857-.681-1.735-1.009-2.608a.96.96,0,0,1,.2-1.018c.245-.2.553-.07.689.291.324.862.66,1.729,1,2.576a.969.969,0,0,1-.18,1.025.39.39,0,0,1-.256.1m-302.863-.5a.508.508,0,0,1-.437-.369c-.342-.858-.679-1.745-1-2.634a.953.953,0,0,1,.208-1.013c.247-.2.554-.058.685.306.315.872.645,1.74.981,2.581a.969.969,0,0,1-.179,1.025.391.391,0,0,1-.256.1M16.95,305.472a.468.468,0,0,1-.394-.278c-.424-.774-.847-1.571-1.258-2.369a1,1,0,0,1,.1-1.049c.223-.25.54-.187.71.142.405.787.823,1.572,1.24,2.335a1.008,1.008,0,0,1-.076,1.052.418.418,0,0,1-.318.167m59.75-.908a.363.363,0,0,1-.162-.039.867.867,0,0,1-.319-.948c.209-.916.4-1.865.577-2.82.072-.4.351-.635.621-.528a.83.83,0,0,1,.357.917c-.179.985-.379,1.963-.594,2.907-.071.313-.268.511-.48.511m262.015-3.257a.524.524,0,0,1-.452-.409c-.306-.888-.609-1.795-.9-2.694a.933.933,0,0,1,.238-1c.252-.178.555-.022.676.351.289.89.588,1.785.891,2.663a.944.944,0,0,1-.222,1.006.377.377,0,0,1-.229.081m-302.777-.579c-.192,0-.375-.162-.461-.436-.283-.906-.558-1.836-.818-2.766a.906.906,0,0,1,.274-.978c.258-.158.555.023.662.4.256.912.526,1.825.8,2.714a.926.926,0,0,1-.248.993.379.379,0,0,1-.211.068m-22.026-1.233a.486.486,0,0,1-.416-.321c-.385-.817-.77-1.656-1.142-2.494a.986.986,0,0,1,.145-1.036c.234-.228.548-.131.7.214.367.826.746,1.654,1.127,2.46a1,1,0,0,1-.126,1.042.4.4,0,0,1-.289.134m64.038-2.172a.323.323,0,0,1-.091-.012.779.779,0,0,1-.408-.87c.118-.954.221-1.936.307-2.919.036-.409.29-.7.568-.645s.473.428.437.838c-.089,1.008-.195,2.016-.315,2.994-.045.362-.258.615-.5.615m258.6-2.77c-.2,0-.382-.167-.464-.449-.271-.913-.538-1.845-.794-2.767a.9.9,0,0,1,.276-.977c.259-.158.555.026.661.409.254.912.518,1.832.785,2.736a.915.915,0,0,1-.261.985.371.371,0,0,1-.2.063M34.044,293.8c-.209,0-.405-.193-.478-.5-.224-.944-.439-1.908-.641-2.866a.855.855,0,0,1,.334-.936c.267-.123.551.1.634.493.2.94.409,1.887.629,2.814a.875.875,0,0,1-.31.954.36.36,0,0,1-.168.043m-22.882-.578a.5.5,0,0,1-.434-.364c-.348-.856-.693-1.732-1.026-2.6a.962.962,0,0,1,.192-1.02c.243-.2.553-.076.69.284.329.86.67,1.724,1.013,2.568a.972.972,0,0,1-.174,1.027.391.391,0,0,1-.26.107m67.383-3.32h-.03c-.279-.025-.492-.379-.476-.792.039-.97.065-1.966.076-2.958,0-.413.232-.746.515-.736s.5.347.5.761c-.011,1.014-.038,2.031-.077,3.022-.016.4-.239.7-.505.7m256.116-2.275c-.206,0-.4-.187-.475-.488-.235-.935-.467-1.886-.688-2.829a.873.873,0,0,1,.313-.952c.265-.136.553.071.645.462.219.932.448,1.873.681,2.8a.885.885,0,0,1-.3.962.363.363,0,0,1-.176.047M8.7,286.683a.524.524,0,0,1-.451-.407c-.31-.89-.615-1.8-.908-2.7a.934.934,0,0,1,.237-1c.252-.179.555-.022.676.351.289.888.59,1.784.9,2.663a.946.946,0,0,1-.219,1.008.378.378,0,0,1-.231.083m23.886-.045c-.227,0-.433-.226-.491-.565-.166-.972-.322-1.96-.464-2.939a.8.8,0,0,1,.389-.889c.273-.087.543.171.6.574.139.962.293,1.933.456,2.887a.822.822,0,0,1-.367.909.357.357,0,0,1-.124.023m45.992-4.215c-.27,0-.494-.315-.506-.717-.028-.974-.07-1.969-.123-2.958-.022-.412.186-.773.465-.806s.523.275.545.687c.054,1.007.1,2.021.125,3.013.012.413-.2.762-.485.779h-.022m254.448-1.873c-.216,0-.416-.206-.484-.526-.2-.949-.4-1.918-.584-2.879a.843.843,0,0,1,.346-.927c.269-.115.55.114.627.512.186.952.381,1.91.578,2.849a.855.855,0,0,1-.333.937.365.365,0,0,1-.15.034M6.54,279.918c-.2,0-.382-.169-.465-.452-.269-.921-.533-1.857-.783-2.785a.9.9,0,0,1,.282-.973c.26-.153.555.033.659.417.247.915.507,1.839.773,2.748a.913.913,0,0,1-.264.984.37.37,0,0,1-.2.061m25.028-.6c-.245,0-.46-.262-.5-.631-.107-.99-.2-2-.286-2.988-.034-.41.163-.784.44-.834s.531.24.565.651c.082.975.176,1.963.281,2.936a.765.765,0,0,1-.42.857.343.343,0,0,1-.08.01m46.566-4.339c-.25,0-.468-.274-.5-.651-.087-.97-.186-1.958-.3-2.934a.768.768,0,0,1,.417-.86c.275-.068.537.208.583.616.111.993.212,2,.3,2.983.036.409-.159.786-.436.84a.38.38,0,0,1-.067.006m253.515-1.618c-.226,0-.432-.225-.491-.563-.166-.96-.329-1.943-.484-2.92a.811.811,0,0,1,.378-.9c.272-.094.545.156.609.558.154.968.315,1.939.479,2.89a.824.824,0,0,1-.365.911.369.369,0,0,1-.126.023M4.693,272.952c-.209,0-.4-.192-.478-.5-.225-.947-.444-1.907-.65-2.855a.86.86,0,0,1,.328-.941c.266-.126.552.091.637.484.2.935.419,1.882.641,2.815a.876.876,0,0,1-.309.955.362.362,0,0,1-.168.043M31,271.886c-.264,0-.487-.3-.5-.7-.046-1-.081-2.017-.1-3.016-.009-.413.211-.758.491-.771s.513.312.522.725c.021.98.054,1.975.1,2.96.019.413-.192.77-.471.8l-.035,0M77.27,267.61c-.234,0-.444-.24-.495-.592-.139-.958-.29-1.931-.45-2.892a.816.816,0,0,1,.371-.9c.272-.1.546.146.613.548.162.976.316,1.963.457,2.937a.8.8,0,0,1-.39.889.35.35,0,0,1-.106.016m253.248-1.54c-.236,0-.447-.244-.5-.6-.134-.973-.265-1.966-.387-2.95a.782.782,0,0,1,.407-.872c.276-.073.54.195.59.6.121.975.25,1.958.383,2.922a.792.792,0,0,1-.4.882.345.345,0,0,1-.1.015M3.184,265.814c-.223,0-.427-.219-.488-.552q-.1-.542-.195-1.083c-.107-.61-.212-1.228-.311-1.835a.814.814,0,0,1,.374-.9c.272-.1.546.15.611.552.1.6.2,1.207.307,1.81q.094.533.192,1.067a.833.833,0,0,1-.356.919.358.358,0,0,1-.133.027m27.706-1.4h-.014c-.279-.011-.5-.355-.493-.768.019-1.006.051-2.022.1-3.018.019-.413.261-.723.54-.7s.49.385.472.8c-.044.976-.076,1.971-.094,2.958-.007.407-.232.729-.506.729m45.13-4.045c-.218,0-.419-.209-.485-.533-.193-.945-.4-1.894-.615-2.822a.871.871,0,0,1,.315-.951c.265-.134.553.074.644.465.219.945.43,1.913.627,2.875a.851.851,0,0,1-.339.933.36.36,0,0,1-.146.032m253.608-1.655c-.246,0-.462-.264-.5-.634-.1-.979-.2-1.98-.293-2.973-.038-.409.156-.787.433-.842s.532.231.571.64c.091.984.188,1.975.29,2.946a.762.762,0,0,1-.423.854.374.374,0,0,1-.078.009m-327.6-.175c-.237,0-.448-.246-.5-.6-.132-.977-.258-1.973-.372-2.96a.773.773,0,0,1,.413-.865c.276-.069.538.2.585.611.113.975.237,1.958.367,2.921a.79.79,0,0,1-.4.881.358.358,0,0,1-.1.014m29.264-1.572a.352.352,0,0,1-.077-.009c-.277-.062-.467-.443-.425-.852.1-.993.234-2,.393-3,.064-.4.337-.651.609-.557a.813.813,0,0,1,.377.9c-.152.954-.279,1.922-.377,2.875-.038.371-.254.637-.5.637m43.04-3.648c-.2,0-.389-.175-.469-.465-.254-.918-.523-1.831-.8-2.716a.925.925,0,0,1,.249-.993c.254-.172.555-.008.671.368.281.9.555,1.837.815,2.774a.9.9,0,0,1-.277.977.371.371,0,0,1-.192.055M328.966,251.3c-.255,0-.475-.284-.5-.667-.073-.991-.142-2-.2-2.988-.026-.412.18-.775.458-.814s.525.266.55.677c.061.984.129,1.98.2,2.962.03.411-.17.78-.449.825a.426.426,0,0,1-.056,0M1.2,251.159c-.25,0-.468-.273-.5-.651-.089-.989-.17-1.995-.241-2.989-.029-.411.172-.779.45-.823s.528.254.558.665c.07.981.15,1.975.237,2.951.037.409-.158.786-.436.84a.321.321,0,0,1-.067.006m31.343-1.426a.363.363,0,0,1-.173-.045.881.881,0,0,1-.3-.959c.232-.948.493-1.9.775-2.823.115-.376.414-.545.67-.375a.92.92,0,0,1,.254.989c-.272.892-.523,1.807-.747,2.72-.075.3-.269.493-.476.493m39.623-3.176a.517.517,0,0,1-.445-.391c-.322-.874-.657-1.736-1-2.56a.974.974,0,0,1,.169-1.028c.238-.216.55-.1.7.249.349.845.693,1.729,1.023,2.624a.956.956,0,0,1-.2,1.015.381.381,0,0,1-.241.091m256.358-2.705c-.265,0-.487-.3-.5-.7-.044-.994-.083-2-.117-3-.014-.413.2-.764.481-.784s.517.3.531.711c.033.986.071,1.986.115,2.972.019.412-.193.768-.472.8l-.034,0M.7,243.719c-.264,0-.487-.3-.5-.7-.046-.992-.084-2-.114-3-.012-.413.2-.762.484-.78s.516.3.528.715c.029.989.067,1.988.112,2.968.019.412-.192.769-.471.8a.261.261,0,0,1-.035,0m34-.742a.387.387,0,0,1-.257-.1.969.969,0,0,1-.179-1.025c.348-.872.722-1.735,1.112-2.565.16-.34.475-.425.705-.189a.993.993,0,0,1,.127,1.042c-.376.8-.736,1.632-1.072,2.473a.508.508,0,0,1-.437.368m34.773-2.743a.481.481,0,0,1-.41-.307c-.4-.8-.809-1.585-1.224-2.323a1.012,1.012,0,0,1,.066-1.054.406.406,0,0,1,.714.1c.429.762.853,1.568,1.263,2.4a1,1,0,0,1-.111,1.046.406.406,0,0,1-.3.144M37.663,236.92a.425.425,0,0,1-.334-.185,1.015,1.015,0,0,1-.047-1.056c.455-.767.933-1.512,1.421-2.214a.4.4,0,0,1,.717.014,1.016,1.016,0,0,1-.01,1.058c-.468.674-.928,1.39-1.366,2.128a.457.457,0,0,1-.381.255m290.636-.535c-.274,0-.5-.323-.506-.73-.016-.99-.028-2-.033-3,0-.413.222-.751.5-.755h0c.278,0,.5.331.506.742.006.993.017,1.994.033,2.976.007.413-.215.756-.494.767H328.3M.509,236.248c-.278,0-.5-.331-.506-.743q0-.475,0-.952c0-.68,0-1.372.011-2.057,0-.409.23-.736.506-.736H.526c.28.006.5.347.5.76-.007.676-.011,1.36-.011,2.033q0,.47,0,.94c0,.413-.223.751-.5.755Zm65.662-1.668a.438.438,0,0,1-.352-.211c-.481-.689-.978-1.346-1.478-1.953a1.012,1.012,0,0,1-.069-1.054.406.406,0,0,1,.713-.1c.521.633,1.039,1.317,1.539,2.034a1.018,1.018,0,0,1,.011,1.058.445.445,0,0,1-.364.228m-24.81-2.754a.477.477,0,0,1-.405-.3,1,1,0,0,1,.1-1.048c.555-.618,1.13-1.2,1.708-1.728.238-.217.55-.109.7.243a.976.976,0,0,1-.164,1.03c-.552.505-1.1,1.06-1.632,1.651a.411.411,0,0,1-.3.15m20.834-1.845a.392.392,0,0,1-.264-.11,18.75,18.75,0,0,0-1.73-1.393.933.933,0,0,1-.237-1c.121-.373.424-.529.676-.352a19.788,19.788,0,0,1,1.821,1.466.976.976,0,0,1,.167,1.03.5.5,0,0,1-.432.357m266.082-1.068h-.008c-.279-.006-.5-.346-.5-.759.01-.994.027-2,.047-3,.009-.413.238-.732.522-.725s.5.358.491.771c-.021.989-.036,1.992-.047,2.978,0,.41-.23.738-.506.738M.619,228.773H.593c-.279-.021-.495-.372-.481-.785.034-.993.076-2,.125-3,.021-.412.264-.722.542-.693s.488.388.468.8c-.048.988-.09,1.986-.124,2.968-.014.4-.237.711-.506.711m45.1-.712c-.2,0-.384-.17-.466-.453a.912.912,0,0,1,.266-.983,15.935,15.935,0,0,1,1.95-1.058c.268-.121.551.1.633.5a.851.851,0,0,1-.336.935,15.1,15.1,0,0,0-1.847,1,.372.372,0,0,1-.2.06m11.868-1.112a.35.35,0,0,1-.142-.031,13.054,13.054,0,0,0-1.914-.652.774.774,0,0,1-.413-.866c.048-.407.31-.68.585-.61a13.771,13.771,0,0,1,2.025.691.843.843,0,0,1,.345.927c-.065.327-.267.54-.486.54m-7.009-.858c-.252,0-.47-.277-.5-.656-.035-.41.162-.784.44-.836a11.945,11.945,0,0,1,2.078-.2h0c.279,0,.505.333.506.745s-.224.75-.5.752a11.247,11.247,0,0,0-1.957.187.345.345,0,0,1-.064.006m277.872-4.651-.028,0c-.279-.022-.494-.375-.479-.787.036-1,.078-2,.125-3,.02-.413.262-.724.541-.695s.49.386.47.8c-.046.985-.088,1.985-.124,2.974-.015.4-.238.709-.505.709M1.014,221.32a.416.416,0,0,1-.054,0c-.278-.044-.48-.413-.451-.824.071-.987.15-1.992.236-2.987.035-.409.289-.7.566-.647s.474.426.439.837c-.085.984-.163,1.979-.233,2.955-.028.385-.248.67-.5.67m327.806-7.337a.313.313,0,0,1-.047,0c-.279-.038-.484-.4-.459-.813.062-.994.129-2,.2-2.987.03-.411.28-.708.557-.665s.48.413.45.824c-.071.981-.138,1.979-.2,2.966-.024.388-.245.68-.5.68M1.679,213.908a.343.343,0,0,1-.08-.009.765.765,0,0,1-.421-.857c.106-.984.221-1.981.34-2.964.05-.407.313-.677.589-.6a.778.778,0,0,1,.409.869c-.119.973-.232,1.96-.336,2.934-.04.368-.255.631-.5.631m.919-7.352a.343.343,0,0,1-.1-.016.8.8,0,0,1-.391-.886c.139-.974.286-1.961.438-2.935.063-.4.335-.654.608-.562a.81.81,0,0,1,.38.9c-.151.964-.3,1.942-.434,2.907-.05.352-.261.594-.5.594m326.778,0a.3.3,0,0,1-.065-.006c-.278-.052-.474-.428-.438-.837.067-.766.138-1.544.211-2.313.021-.22.042-.44.064-.66.039-.409.3-.694.573-.635s.469.438.43.847q-.032.327-.063.656c-.072.765-.143,1.537-.209,2.3-.033.377-.251.652-.5.652m-96.024-5.783c-.279,0-.506-.334-.506-.747s.226-.749.506-.749q1.01,0,2.021-.014h0c.278,0,.5.331.506.742s-.223.751-.5.754q-1.014.012-2.028.014Zm-3.037-.016h0c-.675-.009-1.357-.021-2.028-.036-.28-.006-.5-.347-.5-.759s.236-.746.515-.737q1.011.023,2.021.035c.28,0,.5.342.5.755s-.229.742-.507.742m8.1-.056c-.275,0-.5-.327-.506-.735s.217-.754.5-.762c.673-.018,1.353-.039,2.021-.064.277-.008.512.317.519.73s-.214.757-.494.767c-.67.025-1.352.047-2.028.065h-.009m-13.159-.072h-.013c-.672-.025-1.355-.054-2.027-.086-.28-.014-.5-.359-.49-.772s.247-.736.523-.724c.67.032,1.35.061,2.021.086.279.01.5.354.493.767s-.232.729-.506.729m18.218-.127c-.271,0-.5-.318-.506-.722s.209-.759.488-.774c.673-.035,1.352-.073,2.02-.114.282-.018.516.3.527.716s-.205.762-.485.779c-.67.041-1.351.08-2.027.114h-.018m-23.276-.126h-.022c-.672-.042-1.354-.088-2.026-.137-.279-.02-.495-.371-.481-.784s.25-.73.531-.71c.67.048,1.349.094,2.019.136.28.018.5.366.485.779s-.236.717-.506.717m28.333-.2c-.268,0-.491-.31-.505-.709s.2-.765.48-.786c.672-.052,1.351-.107,2.018-.165.276-.022.519.29.535.7s-.2.767-.476.792c-.669.058-1.35.113-2.025.165h-.027m-33.388-.18h-.03c-.669-.059-1.35-.121-2.024-.187-.279-.026-.491-.383-.472-.8s.261-.724.539-.7c.671.065,1.35.128,2.017.186.279.025.492.379.476.791-.016.4-.24.7-.505.7m38.441-.269c-.264,0-.487-.3-.5-.7-.02-.413.191-.77.47-.8.672-.068,1.35-.141,2.016-.215.277-.031.522.278.543.69s-.188.771-.467.8c-.668.075-1.349.147-2.023.215a.251.251,0,0,1-.035,0m-43.491-.234-.039,0c-.673-.076-1.353-.155-2.022-.237-.279-.034-.486-.395-.463-.807s.266-.719.546-.684c.666.081,1.344.161,2.015.237.279.031.488.391.467.8-.02.393-.242.692-.5.692M3.757,199.278a.361.361,0,0,1-.128-.024.827.827,0,0,1-.363-.913c.169-.962.348-1.938.53-2.9.075-.4.355-.631.624-.52a.838.838,0,0,1,.352.923c-.181.954-.358,1.922-.525,2.875-.059.336-.265.56-.49.56m326.349-.125a.354.354,0,0,1-.081-.01.766.766,0,0,1-.419-.858c.108-.989.222-1.984.337-2.958.048-.407.311-.68.586-.609a.774.774,0,0,1,.412.866c-.114.968-.227,1.958-.334,2.94-.04.368-.255.629-.5.629m-71.478,0c-.26,0-.482-.294-.5-.685-.024-.412.183-.774.461-.809q1.008-.128,2.014-.265c.278-.039.525.265.55.676s-.179.775-.457.814q-1.01.138-2.021.265l-.044,0m-53.581-.288a.316.316,0,0,1-.047,0c-.672-.092-1.351-.189-2.018-.287-.279-.041-.482-.408-.454-.819s.276-.711.555-.67c.665.1,1.342.194,2.012.286.278.038.483.4.457.814-.025.388-.246.68-.5.68m58.62-.413c-.256,0-.476-.287-.5-.672-.029-.412.174-.779.452-.821.664-.1,1.341-.207,2.01-.315.278-.044.528.252.559.663s-.17.78-.448.825c-.672.109-1.351.216-2.017.316a.388.388,0,0,1-.053,0m-63.656-.343a.33.33,0,0,1-.056,0c-.669-.109-1.347-.223-2.015-.338-.278-.048-.477-.42-.444-.83s.284-.7.562-.656c.666.115,1.342.228,2.009.336.278.045.479.415.448.826-.029.383-.248.666-.5.666m68.686-.483c-.253,0-.472-.279-.5-.66-.034-.41.164-.783.443-.833.668-.117,1.343-.241,2.006-.364.278-.052.531.238.566.648s-.161.784-.439.837c-.665.124-1.342.248-2.013.366a.313.313,0,0,1-.061.006m-73.713-.4a.355.355,0,0,1-.064-.006c-.667-.126-1.344-.256-2.011-.388-.278-.056-.472-.432-.435-.841s.292-.7.57-.643c.664.132,1.339.261,2,.387.277.052.474.426.438.837-.032.378-.25.654-.5.654m78.733-.556c-.249,0-.466-.272-.5-.647-.038-.409.156-.787.433-.843.669-.136,1.343-.275,2-.416.276-.059.534.225.573.635s-.152.788-.429.847c-.662.141-1.337.281-2.009.417a.348.348,0,0,1-.07.007m-83.748-.45a.325.325,0,0,1-.073-.008c-.664-.142-1.339-.289-2.006-.438-.277-.062-.467-.443-.425-.852s.3-.69.577-.628c.665.149,1.338.3,2,.437.277.059.469.438.429.847-.036.373-.253.642-.5.642m88.757-.628c-.246,0-.462-.265-.5-.634a.763.763,0,0,1,.424-.854c.663-.151,1.335-.307,2-.466.277-.066.536.212.581.62a.765.765,0,0,1-.42.857c-.664.158-1.338.316-2,.467a.325.325,0,0,1-.078.009m-93.761-.5a.352.352,0,0,1-.082-.01c-.661-.158-1.334-.322-2-.488a.772.772,0,0,1-.415-.863c.047-.407.308-.683.584-.613.664.165,1.334.329,1.994.487a.766.766,0,0,1,.419.858c-.04.368-.255.629-.5.629m98.756-.7c-.242,0-.456-.257-.5-.622a.774.774,0,0,1,.413-.865c.665-.169,1.336-.342,1.991-.516.276-.073.538.2.588.6a.777.777,0,0,1-.41.869c-.658.174-1.33.347-2,.517a.317.317,0,0,1-.087.011m-103.746-.556a.349.349,0,0,1-.09-.012c-.666-.176-1.338-.358-1.995-.538a.782.782,0,0,1-.405-.873c.051-.406.315-.675.591-.6.655.18,1.324.361,1.988.537a.777.777,0,0,1,.409.869c-.044.362-.257.616-.5.616m108.727-.774c-.239,0-.451-.25-.5-.609a.784.784,0,0,1,.4-.875c.66-.184,1.327-.375,1.985-.565.275-.08.541.184.595.59a.789.789,0,0,1-.4.879c-.659.191-1.33.382-1.992.568a.354.354,0,0,1-.095.013M175,192.451a.353.353,0,0,1-.1-.015c-.663-.193-1.332-.391-1.988-.589a.793.793,0,0,1-.4-.883c.056-.4.324-.665.6-.583.654.2,1.321.395,1.982.586a.79.79,0,0,1,.4.879c-.047.357-.259.6-.5.6m-169.86-.363a.357.357,0,0,1-.151-.035.855.855,0,0,1-.333-.937c.2-.955.417-1.918.64-2.863.093-.39.381-.6.645-.46a.876.876,0,0,1,.311.953c-.219.93-.431,1.877-.63,2.815-.068.32-.267.526-.483.526m325.848-.3a.367.367,0,0,1-.1-.014.788.788,0,0,1-.4-.878c.129-.979.262-1.968.4-2.941.056-.4.324-.665.6-.582a.8.8,0,0,1,.394.885c-.135.967-.268,1.95-.4,2.923-.047.358-.259.606-.5.606m-37.322-.189c-.235,0-.446-.243-.5-.6a.8.8,0,0,1,.393-.885c.653-.2,1.319-.407,1.977-.616.273-.087.543.17.6.575a.8.8,0,0,1-.389.889c-.662.209-1.329.417-1.985.618a.335.335,0,0,1-.1.016m-123.623-.66a.358.358,0,0,1-.107-.017c-.66-.209-1.327-.425-1.981-.639a.8.8,0,0,1-.384-.893c.06-.4.33-.658.6-.568.652.214,1.317.428,1.975.637a.8.8,0,0,1,.389.889c-.051.351-.261.591-.494.591m128.57-.921c-.231,0-.44-.236-.494-.584a.805.805,0,0,1,.383-.895c.656-.219,1.319-.442,1.97-.667.273-.094.545.157.608.56a.811.811,0,0,1-.378.9c-.653.224-1.319.45-1.977.668a.344.344,0,0,1-.112.018m-133.51-.712a.346.346,0,0,1-.115-.02c-.658-.226-1.322-.458-1.974-.689a.814.814,0,0,1-.374-.9c.065-.4.339-.648.611-.553.649.23,1.311.462,1.967.687a.81.81,0,0,1,.378.9c-.054.346-.262.579-.493.579m138.438-1c-.229,0-.436-.229-.492-.571a.817.817,0,0,1,.372-.9c.653-.235,1.313-.476,1.962-.718.271-.1.546.143.615.544a.821.821,0,0,1-.368.908c-.652.242-1.314.483-1.969.72a.371.371,0,0,1-.12.021m-143.358-.763a.354.354,0,0,1-.124-.023c-.656-.244-1.317-.492-1.965-.74a.826.826,0,0,1-.364-.912c.07-.4.347-.64.617-.537.646.247,1.306.5,1.958.738a.82.82,0,0,1,.368.908c-.058.339-.264.566-.491.566m148.265-1.07c-.225,0-.43-.222-.489-.558a.827.827,0,0,1,.362-.914c.645-.25,1.3-.508,1.954-.767.27-.107.548.129.621.528a.832.832,0,0,1-.357.918c-.653.26-1.313.519-1.96.77a.369.369,0,0,1-.129.024m-153.163-.814a.354.354,0,0,1-.132-.026c-.65-.259-1.308-.525-1.956-.79a.836.836,0,0,1-.353-.922c.075-.4.354-.631.623-.521.646.265,1.3.529,1.949.788a.832.832,0,0,1,.358.918c-.061.333-.266.553-.489.553M6.849,185.051a.363.363,0,0,1-.19-.056.9.9,0,0,1-.279-.975c.255-.927.523-1.861.8-2.775.114-.377.414-.547.669-.38a.919.919,0,0,1,.257.988c-.271.9-.535,1.817-.785,2.73-.08.29-.27.467-.47.467m306.487-.528c-.221,0-.425-.216-.487-.546a.837.837,0,0,1,.351-.923c.645-.268,1.3-.543,1.944-.817.269-.115.55.114.627.512a.842.842,0,0,1-.346.927c-.647.276-1.3.552-1.951.82a.351.351,0,0,1-.137.028m18.693-.047a.368.368,0,0,1-.112-.018.807.807,0,0,1-.382-.9c.15-.981.3-1.964.46-2.922.065-.4.338-.65.61-.553a.813.813,0,0,1,.375.9c-.155.952-.308,1.93-.457,2.9-.053.348-.262.584-.494.584m-181.616-.817a.356.356,0,0,1-.14-.03c-.647-.275-1.3-.558-1.947-.84a.849.849,0,0,1-.342-.931c.079-.4.362-.623.63-.505.642.281,1.295.563,1.94.837a.843.843,0,0,1,.346.927c-.064.328-.267.541-.487.541M318.2,182.44c-.218,0-.419-.21-.485-.534a.848.848,0,0,1,.34-.931c.642-.285,1.293-.577,1.934-.868.267-.121.55.1.633.5a.853.853,0,0,1-.335.935c-.643.292-1.3.585-1.941.87a.354.354,0,0,1-.145.032m-172.635-.915a.356.356,0,0,1-.149-.033c-.647-.294-1.3-.593-1.937-.89a.858.858,0,0,1-.331-.939c.084-.394.369-.613.635-.489.635.3,1.285.594,1.93.887a.853.853,0,0,1,.335.935c-.067.322-.267.528-.484.528m177.47-1.3c-.215,0-.414-.2-.482-.521a.858.858,0,0,1,.328-.94c.644-.3,1.29-.612,1.923-.918.266-.129.552.085.639.479a.863.863,0,0,1-.324.943c-.635.307-1.284.617-1.93.921a.361.361,0,0,1-.154.036m-182.3-.965a.353.353,0,0,1-.157-.037c-.64-.309-1.288-.626-1.926-.94a.868.868,0,0,1-.32-.948c.089-.392.376-.6.641-.472.635.314,1.281.629,1.919.937a.864.864,0,0,1,.324.944c-.07.315-.268.516-.481.516M8.943,178.245a.377.377,0,0,1-.228-.08.941.941,0,0,1-.224-1.005c.306-.9.626-1.793.951-2.669.134-.363.442-.5.688-.3a.957.957,0,0,1,.2,1.016c-.32.861-.634,1.745-.935,2.625a.526.526,0,0,1-.452.411m318.9-.352c-.211,0-.408-.2-.48-.508a.868.868,0,0,1,.317-.948c.635-.319,1.279-.644,1.912-.968.265-.135.553.072.645.463a.873.873,0,0,1-.313.952c-.635.326-1.281.652-1.919.972a.357.357,0,0,1-.163.039m5.381-.682a.357.357,0,0,1-.127-.024.825.825,0,0,1-.364-.912q.082-.47.167-.943l-.107.056c-.263.14-.553-.063-.648-.452a.879.879,0,0,1,.306-.956l.767-.409.036-.195c.073-.4.351-.635.622-.526a.533.533,0,0,1,.25.232l.225-.121c.263-.142.554.057.65.445a.884.884,0,0,1-.3.96l-.64.346c-.118.645-.233,1.294-.346,1.939-.059.337-.265.561-.489.561m-197.281-.331a.373.373,0,0,1-.166-.041c-.637-.327-1.281-.66-1.914-.991a.878.878,0,0,1-.309-.956c.094-.389.383-.594.647-.455.63.33,1.272.662,1.907.987a.873.873,0,0,1,.313.952c-.072.31-.269.5-.479.5m-4.768-2.51a.359.359,0,0,1-.174-.046c-.629-.34-1.269-.691-1.9-1.041a.888.888,0,0,1-.3-.964c.1-.387.39-.583.652-.438.63.349,1.269.7,1.9,1.038a.884.884,0,0,1,.3.96c-.075.3-.269.491-.475.491m206.2-1.524c-.2,0-.4-.184-.474-.483a.89.89,0,0,1,.294-.965c.627-.351,1.262-.71,1.887-1.068.261-.15.555.043.655.428a.892.892,0,0,1-.29.968c-.627.36-1.265.72-1.894,1.072a.366.366,0,0,1-.18.049m-210.933-1.111a.363.363,0,0,1-.182-.051c-.63-.36-1.265-.727-1.889-1.092a.9.9,0,0,1-.285-.971c.1-.385.4-.574.657-.421.622.363,1.256.729,1.883,1.087a.894.894,0,0,1,.29.968c-.078.3-.27.479-.473.479M11.41,171.718a.394.394,0,0,1-.265-.111.976.976,0,0,1-.166-1.03c.356-.855.725-1.711,1.1-2.543.155-.345.469-.439.7-.211a.987.987,0,0,1,.143,1.038c-.367.819-.731,1.66-1.08,2.5a.5.5,0,0,1-.432.357m330.675-1.586c-.2,0-.392-.179-.471-.471a.9.9,0,0,1,.283-.973c.624-.369,1.255-.745,1.874-1.118.26-.157.555.027.66.41a.9.9,0,0,1-.277.976c-.621.374-1.254.752-1.881,1.122a.371.371,0,0,1-.188.054m-7.521-.121a.365.365,0,0,1-.143-.03.845.845,0,0,1-.344-.929c.188-.954.384-1.918.58-2.867.082-.395.365-.618.633-.5a.853.853,0,0,1,.337.935c-.195.943-.389,1.9-.577,2.85-.064.327-.266.538-.486.538M121.73,168.973a.365.365,0,0,1-.191-.055c-.623-.375-1.254-.759-1.876-1.141a.907.907,0,0,1-.273-.979c.107-.381.4-.562.662-.4.619.38,1.248.763,1.869,1.137a.9.9,0,0,1,.278.976c-.08.29-.269.466-.469.466m225.037-1.679c-.2,0-.385-.172-.467-.458a.91.91,0,0,1,.271-.981q.734-.456,1.468-.919l.391-.248c.257-.163.555.012.665.393a.912.912,0,0,1-.265.983l-.393.248q-.736.466-1.474.924a.372.372,0,0,1-.2.059M117.06,166.089a.364.364,0,0,1-.2-.061c-.618-.391-1.244-.792-1.862-1.19a.917.917,0,0,1-.261-.986c.112-.378.411-.551.667-.385.615.4,1.239.8,1.855,1.186a.912.912,0,0,1,.266.983c-.082.283-.269.454-.466.454m-102.818-.567a.409.409,0,0,1-.3-.147,1,1,0,0,1-.106-1.046c.405-.809.824-1.615,1.244-2.4a.407.407,0,0,1,.712-.119,1.007,1.007,0,0,1,.081,1.051c-.413.767-.824,1.558-1.222,2.353a.479.479,0,0,1-.408.3m337.171-1.191c-.194,0-.38-.166-.463-.445a.919.919,0,0,1,.258-.988c.62-.406,1.24-.817,1.842-1.221.255-.171.555,0,.671.372a.922.922,0,0,1-.252.99c-.605.406-1.228.819-1.85,1.227a.375.375,0,0,1-.205.064m-238.987-1.249a.37.37,0,0,1-.207-.066q-.922-.609-1.848-1.228a.923.923,0,0,1-.253-.99c.115-.377.415-.545.67-.374q.924.617,1.845,1.227a.92.92,0,0,1,.255.989c-.084.278-.269.443-.463.443m223.63-.2a.362.362,0,0,1-.157-.037.861.861,0,0,1-.325-.943c.207-.94.423-1.9.639-2.841.09-.392.377-.6.642-.469a.87.87,0,0,1,.317.949c-.216.939-.429,1.889-.635,2.825-.07.315-.268.516-.482.516m19.961-1.655c-.19,0-.372-.159-.459-.43a.931.931,0,0,1,.243-1c.613-.425,1.227-.857,1.823-1.281.252-.179.555-.023.676.349a.935.935,0,0,1-.236,1c-.6.427-1.216.861-1.833,1.288a.375.375,0,0,1-.215.072M107.812,160a.373.373,0,0,1-.21-.068l-1.847-1.244a.924.924,0,0,1-.251-.992c.116-.376.417-.541.671-.37l1.846,1.243a.924.924,0,0,1,.251.992c-.085.275-.269.438-.461.438m-90.383-.286a.429.429,0,0,1-.336-.189,1.015,1.015,0,0,1-.042-1.056c.452-.754.919-1.5,1.386-2.221a.4.4,0,0,1,.716-.023,1.015,1.015,0,0,1,.016,1.058c-.458.707-.915,1.441-1.36,2.18a.455.455,0,0,1-.379.252m343.141-1.749a.527.527,0,0,1-.454-.413.941.941,0,0,1,.226-1c.6-.446,1.21-.9,1.8-1.349.248-.188.554-.044.682.324a.947.947,0,0,1-.219,1.008c-.594.45-1.2.907-1.81,1.355a.38.38,0,0,1-.227.08M103.2,156.894a.372.372,0,0,1-.209-.068q-.921-.619-1.846-1.236a.922.922,0,0,1-.253-.99c.115-.377.415-.545.67-.374q.925.618,1.848,1.238a.922.922,0,0,1,.252.991c-.085.276-.269.439-.462.439m234.493-1.077a.356.356,0,0,1-.171-.044.878.878,0,0,1-.305-.957c.228-.938.462-1.885.7-2.814.1-.387.389-.584.651-.44a.886.886,0,0,1,.3.962c-.232.924-.465,1.865-.693,2.8-.074.306-.269.5-.477.5m27.374-1.288a.519.519,0,0,1-.447-.4.951.951,0,0,1,.207-1.013c.6-.471,1.193-.95,1.775-1.423.245-.2.553-.068.688.294a.959.959,0,0,1-.2,1.017c-.586.476-1.186.958-1.785,1.431a.383.383,0,0,1-.238.089m-344.1-.169a.449.449,0,0,1-.371-.238,1.017,1.017,0,0,1,.025-1.058c.5-.686,1.011-1.365,1.522-2.017a.4.4,0,0,1,.714.078,1.014,1.014,0,0,1-.053,1.056c-.5.639-1,1.3-1.493,1.978a.433.433,0,0,1-.345.2m77.617-.544a.372.372,0,0,1-.206-.065q-.924-.609-1.85-1.213a.916.916,0,0,1-.259-.986c.113-.379.412-.55.667-.383q.929.6,1.854,1.215a.921.921,0,0,1,.256.989c-.084.278-.269.444-.463.444M369.494,150.9a.511.511,0,0,1-.44-.376.966.966,0,0,1,.187-1.022c.584-.5,1.171-1,1.744-1.5.241-.212.552-.093.694.262a.971.971,0,0,1-.178,1.026c-.577.5-1.167,1.014-1.755,1.513a.387.387,0,0,1-.252.1m-275.551-.093a.365.365,0,0,1-.2-.061c-.633-.4-1.259-.8-1.859-1.171a.91.91,0,0,1-.27-.981c.109-.381.406-.559.664-.4.6.376,1.231.771,1.865,1.176a.913.913,0,0,1,.265.983c-.083.283-.27.453-.466.453m-69.114-1.272a.474.474,0,0,1-.4-.294,1,1,0,0,1,.1-1.049c.542-.61,1.1-1.21,1.652-1.782.229-.236.545-.154.705.185a.992.992,0,0,1-.125,1.042c-.543.561-1.088,1.148-1.618,1.745a.413.413,0,0,1-.307.153m314.64-.714a.363.363,0,0,1-.185-.052A.9.9,0,0,1,339,147.8c.246-.926.5-1.863.751-2.786.105-.384.4-.569.66-.413a.9.9,0,0,1,.279.975c-.251.918-.5,1.849-.747,2.77-.078.3-.269.475-.472.475m-250.193-.907a.373.373,0,0,1-.191-.055c-.633-.381-1.263-.755-1.873-1.112a.9.9,0,0,1-.284-.972c.1-.384.4-.573.658-.42.613.359,1.246.735,1.882,1.117a.9.9,0,0,1,.278.976c-.08.29-.27.467-.469.467m284.565-.848a.5.5,0,0,1-.431-.354.977.977,0,0,1,.163-1.03c.572-.524,1.147-1.059,1.708-1.59.235-.223.549-.121.7.227a.981.981,0,0,1-.154,1.034c-.565.535-1.144,1.074-1.72,1.6a.393.393,0,0,1-.267.113M29.007,145.324a.5.5,0,0,1-.434-.36.975.975,0,0,1,.17-1.028c.582-.522,1.178-1.031,1.772-1.512.245-.2.553-.066.688.3a.959.959,0,0,1-.2,1.017c-.58.471-1.164.968-1.733,1.478a.391.391,0,0,1-.262.109m55.56-.142a.364.364,0,0,1-.179-.049c-.635-.354-1.271-.7-1.89-1.034a.882.882,0,0,1-.3-.959c.1-.389.386-.59.65-.448.623.334,1.263.684,1.9,1.04a.889.889,0,0,1,.3.964c-.076.3-.27.485-.474.485m293.527-2.172a.491.491,0,0,1-.421-.331.99.99,0,0,1,.138-1.039c.56-.557,1.121-1.123,1.666-1.683.23-.236.546-.153.705.187a1,1,0,0,1-.126,1.042c-.549.565-1.114,1.136-1.679,1.7a.4.4,0,0,1-.283.128m-298.285-.352a.362.362,0,0,1-.163-.04c-.642-.322-1.285-.636-1.911-.935a.86.86,0,0,1-.327-.941c.086-.393.371-.61.638-.483.631.3,1.279.618,1.926.942a.87.87,0,0,1,.317.949c-.072.312-.269.508-.48.508M341.38,141.9a.366.366,0,0,1-.2-.059.908.908,0,0,1-.268-.981c.262-.916.533-1.844.8-2.756.112-.379.41-.553.667-.387a.916.916,0,0,1,.262.985c-.268.907-.537,1.83-.8,2.741-.082.285-.269.456-.467.456M33.469,141.8c-.191,0-.374-.16-.46-.434a.925.925,0,0,1,.247-.993c.617-.423,1.247-.83,1.875-1.209.259-.156.555.027.66.409a.9.9,0,0,1-.277.976c-.613.371-1.229.768-1.832,1.182a.372.372,0,0,1-.213.069M74.991,140.4a.369.369,0,0,1-.143-.03c-.648-.282-1.3-.554-1.934-.811a.834.834,0,0,1-.355-.919c.074-.4.352-.634.622-.525.641.259,1.3.534,1.952.818a.845.845,0,0,1,.344.929c-.065.326-.267.537-.486.537M38.17,139.054c-.212,0-.41-.2-.48-.512a.865.865,0,0,1,.321-.946c.644-.316,1.3-.616,1.956-.892.27-.113.549.117.626.515a.842.842,0,0,1-.348.925c-.64.269-1.283.563-1.914.873a.366.366,0,0,1-.16.038m344.069-.342a.481.481,0,0,1-.409-.306,1,1,0,0,1,.109-1.046c.544-.589,1.088-1.189,1.616-1.782.223-.25.541-.186.71.143a1,1,0,0,1-.1,1.049c-.533.6-1.082,1.2-1.631,1.8a.409.409,0,0,1-.3.145m-312.13-.24a.344.344,0,0,1-.118-.021c-.656-.232-1.314-.454-1.958-.658a.8.8,0,0,1-.389-.89c.059-.4.328-.66.6-.573.652.207,1.318.431,1.981.666a.813.813,0,0,1,.375.9c-.056.344-.263.574-.492.574m-27.06-1.391c-.233,0-.443-.24-.494-.59a.8.8,0,0,1,.388-.89c.662-.212,1.337-.407,2.008-.578.276-.071.538.2.586.609a.775.775,0,0,1-.413.865c-.657.168-1.318.359-1.966.566a.341.341,0,0,1-.108.018m22.114-.134a.339.339,0,0,1-.089-.011c-.663-.173-1.329-.333-1.98-.476-.277-.06-.468-.442-.427-.85s.3-.691.576-.631c.66.146,1.336.308,2.007.483a.776.776,0,0,1,.411.867c-.043.364-.257.619-.5.619m-5-1.042a.286.286,0,0,1-.053,0c-.668-.1-1.339-.19-2-.26-.279-.03-.489-.388-.469-.8s.263-.723.542-.692c.668.071,1.351.16,2.029.264.278.043.48.411.451.822-.027.385-.247.671-.5.671m-12.117-.026c-.255,0-.474-.283-.5-.666-.031-.411.17-.781.448-.826.671-.11,1.356-.2,2.036-.273.279-.029.522.281.541.693s-.191.77-.469.8c-.667.069-1.339.159-2,.267a.335.335,0,0,1-.056,0m7.073-.448H55.1c-.67-.022-1.34-.026-2-.011-.28.012-.51-.325-.514-.738s.22-.754.5-.759c.676-.014,1.358-.01,2.04.012.28.009.5.351.5.764s-.231.732-.506.732m288.3-.38a.378.378,0,0,1-.21-.067.925.925,0,0,1-.252-.992c.277-.9.564-1.816.85-2.725.119-.375.42-.536.674-.362a.929.929,0,0,1,.244.995c-.286.9-.571,1.817-.846,2.712-.085.276-.269.438-.461.438m42.84-.89a.467.467,0,0,1-.4-.28,1.008,1.008,0,0,1,.078-1.052c.525-.622,1.05-1.256,1.56-1.885a.406.406,0,0,1,.713.095,1.012,1.012,0,0,1-.065,1.054c-.515.635-1.045,1.276-1.574,1.9a.417.417,0,0,1-.317.165m3.872-4.817a.456.456,0,0,1-.38-.253,1.015,1.015,0,0,1,.044-1.056c.5-.658,1.007-1.329,1.5-1.993a.4.4,0,0,1,.716.043,1.017,1.017,0,0,1-.029,1.058c-.494.671-1,1.349-1.511,2.013a.426.426,0,0,1-.335.187m-44.559-1.067a.378.378,0,0,1-.221-.075.936.936,0,0,1-.235-1c.3-.9.6-1.809.895-2.7.124-.37.428-.521.679-.338a.94.94,0,0,1,.229,1c-.3.883-.6,1.786-.891,2.684a.53.53,0,0,1-.456.421m48.264-4.024a.444.444,0,0,1-.362-.225,1.017,1.017,0,0,1,.007-1.059c.479-.693.958-1.4,1.423-2.1a.4.4,0,0,1,.716-.012,1.018,1.018,0,0,1,.008,1.058c-.47.71-.954,1.426-1.439,2.127a.44.44,0,0,1-.354.214m-46-2.676a.379.379,0,0,1-.231-.083.944.944,0,0,1-.219-1.007c.305-.88.62-1.778.935-2.667.13-.367.436-.508.683-.316a.948.948,0,0,1,.214,1.01c-.314.886-.627,1.779-.931,2.656a.525.525,0,0,1-.451.407m49.519-2.7a.432.432,0,0,1-.342-.2,1.017,1.017,0,0,1-.032-1.058c.453-.732.9-1.477,1.341-2.214a.4.4,0,0,1,.715-.071,1.015,1.015,0,0,1,.048,1.056c-.441.746-.9,1.5-1.356,2.24a.453.453,0,0,1-.374.243m-47.159-3.933a.384.384,0,0,1-.24-.089.954.954,0,0,1-.206-1.014c.32-.874.646-1.762.972-2.64.134-.362.443-.494.688-.3a.957.957,0,0,1,.2,1.016c-.324.873-.651,1.758-.969,2.629a.518.518,0,0,1-.447.393m50.465-1.721a.418.418,0,0,1-.32-.168,1.011,1.011,0,0,1-.073-1.053c.424-.769.845-1.552,1.252-2.326.172-.327.489-.386.711-.133a1,1,0,0,1,.09,1.05c-.412.783-.837,1.576-1.267,2.354a.466.466,0,0,1-.393.276m-48.015-4.842a.387.387,0,0,1-.248-.1.961.961,0,0,1-.193-1.019c.327-.857.664-1.733,1-2.605.139-.359.449-.483.692-.278a.965.965,0,0,1,.188,1.022c-.337.87-.673,1.743-1,2.6a.513.513,0,0,1-.442.381m51.087-1.1a.406.406,0,0,1-.293-.138,1,1,0,0,1-.119-1.044c.394-.82.776-1.643,1.136-2.445.154-.344.469-.439.7-.212a.987.987,0,0,1,.143,1.038c-.366.817-.755,1.653-1.155,2.486a.483.483,0,0,1-.413.315M355.165,101.9a.392.392,0,0,1-.256-.1.968.968,0,0,1-.181-1.024q.511-1.29,1.031-2.58c.143-.355.454-.472.694-.261a.971.971,0,0,1,.177,1.026q-.518,1.287-1.027,2.572a.509.509,0,0,1-.438.371m51.313-.893a.388.388,0,0,1-.254-.1.966.966,0,0,1-.184-1.023c.34-.866.665-1.737.966-2.59.129-.367.435-.509.683-.319a.948.948,0,0,1,.215,1.01c-.308.873-.64,1.765-.988,2.65a.508.508,0,0,1-.438.372m-48.721-5.529a.389.389,0,0,1-.262-.109.973.973,0,0,1-.17-1.028q.524-1.278,1.056-2.556c.147-.353.459-.463.7-.247a.976.976,0,0,1,.167,1.03q-.53,1.276-1.053,2.55a.5.5,0,0,1-.433.36m51-1.145a.365.365,0,0,1-.2-.06.91.91,0,0,1-.268-.981c.263-.916.508-1.84.726-2.745.094-.389.383-.592.647-.454a.879.879,0,0,1,.307.956c-.224.932-.476,1.883-.748,2.827-.082.285-.27.456-.467.456M360.41,89.112a.4.4,0,0,1-.268-.113.98.98,0,0,1-.161-1.032q.225-.532.451-1.064c.2-.479.421-.975.65-1.476.156-.343.471-.434.7-.2a.99.99,0,0,1,.138,1.039c-.222.488-.435.971-.632,1.436q-.226.532-.45,1.063a.5.5,0,0,1-.43.352m49.96-1.856a.345.345,0,0,1-.122-.022.819.819,0,0,1-.37-.906c.16-.957.3-1.923.406-2.872.047-.408.307-.682.584-.613a.773.773,0,0,1,.414.864c-.113.985-.255,1.988-.42,2.98-.057.341-.264.569-.492.569m-47.092-4.307a.41.41,0,0,1-.307-.154,1,1,0,0,1-.1-1.049c.4-.771.824-1.568,1.264-2.368a.406.406,0,0,1,.712-.109,1.01,1.01,0,0,1,.074,1.053c-.434.788-.853,1.573-1.245,2.332a.474.474,0,0,1-.4.294M411.1,79.871h-.021c-.279-.016-.5-.364-.486-.777.011-.43.017-.867.017-1.3,0-.539-.009-1.084-.027-1.623-.014-.413.2-.764.481-.784s.517.3.531.71c.019.563.028,1.134.028,1.7,0,.453-.006.911-.018,1.36-.011.4-.235.718-.506.718m-44.611-2.7a.427.427,0,0,1-.334-.186,1.015,1.015,0,0,1-.046-1.056c.44-.741.9-1.494,1.361-2.239a.4.4,0,0,1,.715-.045,1.016,1.016,0,0,1,.031,1.057c-.458.738-.911,1.482-1.346,2.215a.458.458,0,0,1-.381.254m44.245-4.743c-.239,0-.451-.251-.5-.611-.122-.96-.275-1.917-.454-2.842a.841.841,0,0,1,.347-.926c.269-.114.549.116.627.513.188.97.348,1.973.476,2.979a.782.782,0,0,1-.4.874.347.347,0,0,1-.094.013m-40.8-.743a.438.438,0,0,1-.354-.213,1.017,1.017,0,0,1-.008-1.058c.475-.719.959-1.436,1.437-2.131a.4.4,0,0,1,.716.009,1.015,1.015,0,0,1-.006,1.058c-.474.689-.952,1.4-1.423,2.11a.445.445,0,0,1-.363.225m3.628-5.216a.452.452,0,0,1-.372-.241,1.017,1.017,0,0,1,.028-1.058c.5-.688,1.013-1.367,1.512-2.018a.4.4,0,0,1,.715.066,1.015,1.015,0,0,1-.045,1.056c-.493.644-1,1.315-1.495,2a.433.433,0,0,1-.343.2m35.66-1.157c-.192,0-.375-.162-.461-.436-.277-.89-.585-1.755-.917-2.573a.974.974,0,0,1,.174-1.027c.24-.212.552-.1.7.257.351.865.677,1.779.969,2.718a.925.925,0,0,1-.249.993.373.373,0,0,1-.211.068m-31.84-3.757a.465.465,0,0,1-.393-.275,1.01,1.01,0,0,1,.072-1.053c.544-.656,1.083-1.284,1.6-1.869.223-.251.541-.187.71.142a1,1,0,0,1-.1,1.049c-.511.575-1.042,1.195-1.577,1.839a.418.418,0,0,1-.32.168M406.5,59.043a.457.457,0,0,1-.381-.254,20.444,20.444,0,0,0-1.384-2.043,1.015,1.015,0,0,1-.047-1.055.4.4,0,0,1,.715-.071,21.852,21.852,0,0,1,1.478,2.181,1.015,1.015,0,0,1-.046,1.056.425.425,0,0,1-.334.187M381.45,57.1a.494.494,0,0,1-.425-.34.984.984,0,0,1,.149-1.035c.573-.549,1.171-1.073,1.778-1.556.246-.2.554-.06.686.3a.954.954,0,0,1-.206,1.014c-.583.463-1.156.966-1.706,1.493a.4.4,0,0,1-.275.121m21.144-2.756a.386.386,0,0,1-.249-.1,13.474,13.474,0,0,0-1.762-1.251.9.9,0,0,1-.281-.973c.1-.384.4-.57.659-.416a14.428,14.428,0,0,1,1.884,1.337.963.963,0,0,1,.191,1.02.512.512,0,0,1-.442.38m-16.648-.653c-.2,0-.394-.18-.472-.475a.9.9,0,0,1,.287-.97,20.647,20.647,0,0,1,1.952-1c.268-.118.55.106.631.5a.849.849,0,0,1-.34.932,19.711,19.711,0,0,0-1.874.956.362.362,0,0,1-.185.051m11.917-1.909a.352.352,0,0,1-.1-.014,12.286,12.286,0,0,0-1.947-.4c-.279-.035-.486-.4-.463-.808s.269-.719.547-.685a13,13,0,0,1,2.061.423.789.789,0,0,1,.4.879c-.048.356-.26.6-.5.6m-7.049-.081c-.244,0-.458-.261-.5-.627a.769.769,0,0,1,.418-.86,15.651,15.651,0,0,1,2.056-.357c.28-.03.521.282.541.694s-.191.77-.469.8a15.045,15.045,0,0,0-1.963.341.327.327,0,0,1-.083.01",
    transform: "translate(-19685.826 4501.27) rotate(101)",
    fill: "#87b1e0",
    opacity: 0.51
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_71899",
    "data-name": "Group 71899",
    transform: "translate(-2722.07 2644.968)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7639",
    "data-name": "Path 7639",
    d: "M632.27,270.225a1.762,1.762,0,1,1,1.762-1.762,1.764,1.764,0,0,1-1.762,1.762m0-2.8a1.04,1.04,0,1,0,1.04,1.04,1.041,1.041,0,0,0-1.04-1.04",
    transform: "translate(-17983.484 1671.432)",
    fill: "#87b1e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_71867",
    "data-name": "Group 71867",
    transform: "translate(-17513.16 1870.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7640",
    "data-name": "Path 7640",
    d: "M272.053,68.42a65.7,65.7,0,1,1-65.7-65.7,65.7,65.7,0,0,1,65.7,65.7",
    transform: "translate(-104.923 -2.03)",
    fill: "rgba(19,15,48,0.06)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7641",
    "data-name": "Path 7641",
    d: "M293.682,101.219a54.527,54.527,0,1,1-54.527-54.527,54.527,54.527,0,0,1,54.527,54.527",
    transform: "translate(-137.722 -34.83)",
    fill: "rgba(19,15,48,0.08)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7642",
    "data-name": "Path 7642",
    d: "M293.84,493.057h-.009l-.474-.018a.236.236,0,1,1,.02-.472l.471.019a.236.236,0,0,1-.008.473",
    transform: "translate(-218.66 -367.427)",
    fill: "#87b1e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7644",
    "data-name": "Path 7644",
    d: "M165.889,126.539a1.765,1.765,0,1,1,1.765-1.765,1.767,1.767,0,0,1-1.765,1.765m0-2.806a1.041,1.041,0,1,0,1.041,1.041,1.042,1.042,0,0,0-1.041-1.041",
    transform: "translate(-122.428 -91.758)",
    fill: "#87b1e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7645",
    "data-name": "Path 7645",
    d: "M84.243,429.813h-.929V428.5a.264.264,0,0,0-.528,0v1.311h-.929a.264.264,0,0,0,0,.527h.929v1.311a.264.264,0,0,0,.528,0V430.34h.929a.264.264,0,1,0,0-.527",
    transform: "translate(-60.863 -319.442)",
    fill: "#87b1e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7646",
    "data-name": "Path 7646",
    d: "M580.14,6.884h-1.395V4.917a.4.4,0,0,0-.792,0V6.884h-1.395a.4.4,0,1,0,0,.792h1.395V9.643a.4.4,0,0,0,.792,0V7.676h1.395a.4.4,0,0,0,0-.792",
    transform: "translate(-429.784 -3.372)",
    fill: "#87b1e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7647",
    "data-name": "Path 7647",
    d: "M187.812,39.764h-4.319a.594.594,0,1,1,0-1.189h4.319a.594.594,0,1,1,0,1.189",
    transform: "translate(-136.432 -28.775)",
    fill: "#87b1e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7648",
    "data-name": "Path 7648",
    d: "M222.068,5.508a.6.6,0,0,1-.594-.594V.594a.594.594,0,0,1,1.189,0V4.913a.6.6,0,0,1-.594.594",
    transform: "translate(-165.206 0)",
    fill: "#87b1e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7649",
    "data-name": "Path 7649",
    d: "M197.758,15.454a.593.593,0,0,1-.421-.174l-2.967-2.967a.594.594,0,0,1,.841-.841l2.967,2.967a.594.594,0,0,1-.42,1.015",
    transform: "translate(-144.86 -8.428)",
    fill: "#87b1e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7651",
    "data-name": "Path 7651",
    d: "M313.192,51.231v97.584a7.974,7.974,0,0,1-7.974,7.975h-73.1a7.969,7.969,0,0,1-7.829-7.974V51.231a7.975,7.975,0,0,1,7.974-7.976h72.953a7.975,7.975,0,0,1,7.974,7.976",
    transform: "translate(-167.309 -32.266)",
    fill: "#14244d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7652",
    "data-name": "Path 7652",
    d: "M363.792,118.355v86.48a7.975,7.975,0,0,1-7.974,7.976H292.126c70.681-3.25,71.666-94.456,71.666-94.456",
    transform: "translate(-217.91 -88.286)",
    fill: "#14244d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7653",
    "data-name": "Path 7653",
    d: "M259.388,68.138V162.03l5.41,5.41h65.657v-99.3Z",
    transform: "translate(-193.489 -50.827)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7654",
    "data-name": "Path 7654",
    d: "M264.8,443.12l-5.41-5.41h5.41Z",
    transform: "translate(-193.489 -326.507)",
    fill: "#87b1e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7655",
    "data-name": "Path 7655",
    d: "M301.982,373.542a7.506,7.506,0,1,1-7.505-7.506,7.506,7.506,0,0,1,7.505,7.506",
    transform: "translate(-214.064 -273.043)",
    fill: "rgba(87,140,202,0.21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7656",
    "data-name": "Path 7656",
    d: "M391.2,380.132H365.68a1.305,1.305,0,0,1,0-2.61H391.2a1.305,1.305,0,0,1,0,2.61",
    transform: "translate(-271.805 -281.611)",
    fill: "#1a2b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7657",
    "data-name": "Path 7657",
    d: "M395.908,405.972H365.68a1.305,1.305,0,1,1,0-2.61h30.228a1.305,1.305,0,0,1,0,2.61",
    transform: "translate(-271.805 -300.886)",
    fill: "#578cca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7658",
    "data-name": "Path 7658",
    d: "M301.982,286.295a7.506,7.506,0,1,1-7.505-7.506,7.506,7.506,0,0,1,7.505,7.506",
    transform: "translate(-214.064 -207.961)",
    fill: "rgba(87,140,202,0.21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7659",
    "data-name": "Path 7659",
    d: "M365.68,316.114H391.2a1.305,1.305,0,0,1,0,2.61H365.68a1.305,1.305,0,1,1,0-2.61",
    transform: "translate(-271.805 -235.804)",
    fill: "#578cca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7660",
    "data-name": "Path 7660",
    d: "M365.68,290.275h30.228a1.305,1.305,0,1,1,0,2.61H365.68a1.305,1.305,0,1,1,0-2.61",
    transform: "translate(-271.805 -216.529)",
    fill: "#1a2b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7661",
    "data-name": "Path 7661",
    d: "M301.982,199.047a7.506,7.506,0,1,1-7.505-7.506,7.506,7.506,0,0,1,7.505,7.506",
    transform: "translate(-214.064 -142.879)",
    fill: "rgba(87,140,202,0.21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7662",
    "data-name": "Path 7662",
    d: "M383.252,205.637H365.68a1.305,1.305,0,1,1,0-2.61h17.572a1.305,1.305,0,0,1,0,2.61",
    transform: "translate(-271.805 -151.447)",
    fill: "#578cca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7663",
    "data-name": "Path 7663",
    d: "M391.2,231.477H365.68a1.305,1.305,0,0,1,0-2.61H391.2a1.305,1.305,0,0,1,0,2.61",
    transform: "translate(-271.805 -170.722)",
    fill: "#1a2b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7664",
    "data-name": "Path 7664",
    d: "M301.982,118.087a7.506,7.506,0,1,1-7.505-7.506,7.506,7.506,0,0,1,7.505,7.506",
    transform: "translate(-214.064 -82.487)",
    fill: "rgba(87,140,202,0.21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7665",
    "data-name": "Path 7665",
    d: "M391.2,124.677H365.68a1.305,1.305,0,0,1,0-2.61H391.2a1.305,1.305,0,0,1,0,2.61",
    transform: "translate(-271.805 -91.055)",
    fill: "#1a2b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7666",
    "data-name": "Path 7666",
    d: "M395.908,150.517H365.68a1.305,1.305,0,0,1,0-2.61h30.228a1.305,1.305,0,0,1,0,2.61",
    transform: "translate(-271.805 -110.33)",
    fill: "#578cca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7667",
    "data-name": "Path 7667",
    d: "M368.466,22h-7.092a1.5,1.5,0,0,1-1.5-1.5,2.077,2.077,0,0,0-2.071-2.071h-5.878a2.077,2.077,0,0,0-2.071,2.071,1.5,1.5,0,0,1-1.5,1.5h-7.091a1.514,1.514,0,0,0-1.515,1.515V32.62a1.512,1.512,0,0,0,.791,1.33,1.478,1.478,0,0,0,.724.185h27.209a1.516,1.516,0,0,0,1.514-1.516V23.512A1.515,1.515,0,0,0,368.466,22",
    transform: "translate(-253.429 -13.743)",
    fill: "#87b1e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7668",
    "data-name": "Path 7668",
    d: "M371.173,46.431h-.951a.236.236,0,0,1,0-.473h.948a.236.236,0,1,1,0,.473m-2.373,0h-.949a.236.236,0,0,1,0-.473h.949a.236.236,0,1,1,0,.473m-2.371,0h-.948a.236.236,0,0,1,0-.473h.948a.236.236,0,1,1,0,.473m-2.371,0h-.948a.236.236,0,0,1,0-.473h.948a.236.236,0,1,1,0,.473m-2.371,0h-.949a.236.236,0,0,1,0-.473h.949a.236.236,0,1,1,0,.473m-2.371,0h-.948a.236.236,0,0,1,0-.473h.948a.236.236,0,1,1,0,.473m-2.371,0H356a.236.236,0,0,1,0-.473h.948a.236.236,0,1,1,0,.473m-2.371,0h-.948a.236.236,0,0,1,0-.473h.948a.236.236,0,1,1,0,.473m-2.371,0h-.948a.236.236,0,0,1,0-.473h.948a.236.236,0,1,1,0,.473m-2.371,0h-.948a.236.236,0,0,1,0-.473h.948a.236.236,0,1,1,0,.473m-2.371,0h-.948a.236.236,0,1,1,0-.473h.948a.236.236,0,1,1,0,.473m-2.371,0h-.533a.787.787,0,0,1-.539-.213.236.236,0,0,1,.323-.345.314.314,0,0,0,.216.086h.533a.236.236,0,0,1,0,.473m26.635-1.109a.236.236,0,0,1-.237-.236v-.949a.236.236,0,0,1,.473,0v.949a.236.236,0,0,1-.236.236M344,44.908a.236.236,0,0,1-.237-.236v-.948a.236.236,0,1,1,.473,0v.948a.236.236,0,0,1-.236.236m27.721-1.958a.237.237,0,0,1-.237-.236v-.949a.236.236,0,0,1,.473,0v.949a.236.236,0,0,1-.236.236M344,42.537a.236.236,0,0,1-.237-.236v-.948a.236.236,0,1,1,.473,0V42.3a.236.236,0,0,1-.236.236m27.721-1.958a.237.237,0,0,1-.237-.236v-.949a.236.236,0,0,1,.473,0v.949a.236.236,0,0,1-.236.236M344,40.166a.236.236,0,0,1-.237-.236v-.948a.236.236,0,1,1,.473,0v.948a.236.236,0,0,1-.236.236m27.721-1.958a.237.237,0,0,1-.237-.236v-.731a.31.31,0,0,0-.024-.12.236.236,0,1,1,.436-.182.781.781,0,0,1,.06.3v.731a.236.236,0,0,1-.236.236M344,37.795a.236.236,0,0,1-.237-.236v-.318a.793.793,0,0,1,.459-.717.236.236,0,0,1,.2.429.319.319,0,0,0-.185.288v.318a.236.236,0,0,1-.236.236m26.4-.871h-.948a.236.236,0,0,1,0-.473h.948a.236.236,0,1,1,0,.473m-2.371,0h-.948a.236.236,0,0,1,0-.473h.948a.236.236,0,1,1,0,.473m-2.371,0h-.948a.236.236,0,0,1,0-.473h.948a.236.236,0,1,1,0,.473m-2.371,0h-.948a.236.236,0,0,1,0-.473h.948a.236.236,0,1,1,0,.473m-2.371,0h-.948a.236.236,0,0,1,0-.473h.948a.236.236,0,1,1,0,.473m-2.371,0H357.6a.236.236,0,0,1,0-.473h.948a.236.236,0,1,1,0,.473m-2.371,0h-.948a.236.236,0,0,1,0-.473h.948a.236.236,0,1,1,0,.473m-2.371,0h-.948a.236.236,0,0,1,0-.473h.948a.236.236,0,1,1,0,.473m-2.371,0h-.948a.236.236,0,0,1,0-.473h.948a.236.236,0,1,1,0,.473m-2.371,0h-.948a.236.236,0,1,1,0-.473h.948a.236.236,0,1,1,0,.473m-2.371,0h-.948a.236.236,0,1,1,0-.473h.948a.236.236,0,0,1,0,.473",
    transform: "translate(-256.43 -27.19)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27557",
    "data-name": "Rectangle 27557",
    width: 203.81,
    height: 132.087,
    transform: "translate(0 0)",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71901",
    "data-name": "Group 71901",
    transform: "translate(-3322.068 2935.968)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71894",
    "data-name": "Group 71894",
    transform: "translate(-16919.268 1870.375)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71880",
    "data-name": "Group 71880",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71879",
    "data-name": "Group 71879",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7763",
    "data-name": "Path 7763",
    d: "M272.053,68.42a65.7,65.7,0,1,1-65.7-65.7,65.7,65.7,0,0,1,65.7,65.7",
    transform: "translate(-104.922 -2.03)",
    fill: "rgba(19,15,48,0.06)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7764",
    "data-name": "Path 7764",
    d: "M293.682,101.219a54.527,54.527,0,1,1-54.527-54.527,54.527,54.527,0,0,1,54.527,54.527",
    transform: "translate(-137.722 -34.83)",
    fill: "rgba(19,15,48,0.08)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7765",
    "data-name": "Path 7765",
    d: "M293.84,493.057h-.009l-.474-.018a.236.236,0,1,1,.02-.472l.471.019a.236.236,0,0,1-.008.473",
    transform: "translate(-218.66 -367.427)",
    fill: "#87b1e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7767",
    "data-name": "Path 7767",
    d: "M799.218,452.866h0l-.474-.007a.236.236,0,0,1,0-.473h0l.471.007a.236.236,0,0,1,0,.473",
    transform: "translate(-595.644 -337.455)",
    fill: "#87b1e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7768",
    "data-name": "Path 7768",
    d: "M632.27,270.225a1.762,1.762,0,1,1,1.762-1.762,1.764,1.764,0,0,1-1.762,1.762m0-2.8a1.04,1.04,0,1,0,1.04,1.04,1.041,1.041,0,0,0-1.04-1.04",
    transform: "translate(-470.324 -198.944)",
    fill: "#87b1e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7769",
    "data-name": "Path 7769",
    d: "M165.889,126.539a1.765,1.765,0,1,1,1.765-1.765,1.767,1.767,0,0,1-1.765,1.765m0-2.806a1.041,1.041,0,1,0,1.041,1.041,1.042,1.042,0,0,0-1.041-1.041",
    transform: "translate(-122.428 -91.758)",
    fill: "#87b1e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7770",
    "data-name": "Path 7770",
    d: "M84.243,429.813h-.929V428.5a.264.264,0,0,0-.528,0v1.311h-.929a.264.264,0,0,0,0,.527h.929v1.311a.264.264,0,0,0,.528,0V430.34h.929a.264.264,0,1,0,0-.527",
    transform: "translate(-60.864 -319.442)",
    fill: "#87b1e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7771",
    "data-name": "Path 7771",
    d: "M580.14,6.884h-1.395V4.917a.4.4,0,0,0-.792,0V6.884h-1.395a.4.4,0,1,0,0,.792h1.395V9.643a.4.4,0,0,0,.792,0V7.676h1.395a.4.4,0,0,0,0-.792",
    transform: "translate(-429.785 -3.372)",
    fill: "#87b1e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7772",
    "data-name": "Path 7772",
    d: "M190.136,40.326h-6.361a.876.876,0,1,1,0-1.751h6.361a.876.876,0,1,1,0,1.751",
    transform: "translate(-160.63 -17.475)",
    fill: "#87b1e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7773",
    "data-name": "Path 7773",
    d: "M222.349,8.112a.876.876,0,0,1-.876-.876V.876a.876.876,0,0,1,1.751,0V7.236a.876.876,0,0,1-.876.876",
    transform: "translate(-184.769 6.666)",
    fill: "#87b1e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7774",
    "data-name": "Path 7774",
    d: "M199.442,17.419a.873.873,0,0,1-.619-.256l-4.37-4.37a.876.876,0,1,1,1.238-1.238l4.37,4.369a.876.876,0,0,1-.619,1.495",
    transform: "translate(-167.698 -0.405)",
    fill: "#87b1e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7776",
    "data-name": "Path 7776",
    d: "M180.359,480.787v1.394l-2.09-.7Z",
    transform: "translate(-132.979 -358.641)",
    fill: "#1a2b5b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71881",
    "data-name": "Group 71881",
    transform: "translate(37.248 22.926)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27567",
    "data-name": "Rectangle 27567",
    width: 135.265,
    height: 79.096,
    rx: 4,
    transform: "translate(0 0)",
    fill: "#14244d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27568",
    "data-name": "Rectangle 27568",
    width: 125.521,
    height: 71.072,
    rx: 1,
    transform: "translate(5.158 4.012)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_71884",
    "data-name": "Group 71884",
    transform: "translate(43.123 28.49)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27569",
    "data-name": "Rectangle 27569",
    width: 123.998,
    height: 8.023,
    fill: "#ffcfd3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_71883",
    "data-name": "Group 71883"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71882",
    "data-name": "Group 71882",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7777",
    "data-name": "Path 7777",
    d: "M485.115,10.512a1.989,1.989,0,1,0-1.989,1.989,1.989,1.989,0,0,0,1.989-1.989",
    transform: "translate(-366.971 -6.501)",
    fill: "#e0777f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7778",
    "data-name": "Path 7778",
    d: "M461.361,10.512a1.989,1.989,0,1,0-1.989,1.989,1.99,1.99,0,0,0,1.989-1.989",
    transform: "translate(-348.854 -6.501)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7779",
    "data-name": "Path 7779",
    d: "M67.04,13.053H22.727a.361.361,0,0,1-.361-.361V9.933a.361.361,0,0,1,.361-.361H67.04a.361.361,0,0,1,.361.361v2.759a.361.361,0,0,1-.361.361",
    transform: "translate(-17.059 -7.301)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7780",
    "data-name": "Path 7780",
    d: "M332.887,92.7H291.333a1.741,1.741,0,0,1,0-3.481h41.554a1.741,1.741,0,1,1,0,3.481",
    transform: "translate(-220.878 -57.586)",
    fill: "#ffd4d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7781",
    "data-name": "Path 7781",
    d: "M332.887,122.04H291.333a1.741,1.741,0,0,1,0-3.481h41.554a1.741,1.741,0,1,1,0,3.481",
    transform: "translate(-220.878 -79.966)",
    fill: "#ffd4d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7782",
    "data-name": "Path 7782",
    d: "M314.9,151.383H291.334a1.741,1.741,0,0,1,0-3.481H314.9a1.741,1.741,0,1,1,0,3.481",
    transform: "translate(-220.879 -102.347)",
    fill: "#ffd4d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7783",
    "data-name": "Path 7783",
    d: "M74.352,108.384H19.1a1.4,1.4,0,0,1-1.4-1.4V54.155a1.4,1.4,0,0,1,1.4-1.4H74.352a1.4,1.4,0,0,1,1.4,1.4V106.98a1.4,1.4,0,0,1-1.4,1.4",
    transform: "translate(-13.494 -41.234)",
    fill: "#ffcff6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7784",
    "data-name": "Path 7784",
    d: "M87.667,99.293l5.412.868a.407.407,0,0,0,.433-.23l2.409-5.169a.407.407,0,0,0-.159-.52L84.835,87.654a.405.405,0,0,0-.6.245c-.355,1.4-1.628,5.069-5.242,5.126C75.376,92.968,74.1,89.3,73.748,87.9a.405.405,0,0,0-.6-.245L62.217,94.242a.407.407,0,0,0-.159.52l2.409,5.169a.407.407,0,0,0,.433.23l5.412-.868a.405.405,0,0,1,.382.147c.74.924,3.978,5.076,3.779,6.717S66.241,121.75,64.446,124.85a.406.406,0,0,0,.353.609H93.181a.406.406,0,0,0,.353-.609c-1.8-3.1-9.828-17.048-10.027-18.693s3.038-5.793,3.779-6.717a.4.4,0,0,1,.382-.147",
    transform: "translate(-47.304 -66.81)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7785",
    "data-name": "Path 7785",
    d: "M334.5,233.854H293.719a1.506,1.506,0,0,1-1.506-1.506V228a1.506,1.506,0,0,1,1.506-1.506H334.5A1.506,1.506,0,0,1,336,228v4.345a1.506,1.506,0,0,1-1.506,1.506",
    transform: "translate(-222.876 -172.754)",
    fill: "#95a9f0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71945",
    "data-name": "Group 71945",
    transform: "translate(-3092.732 2724.968)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71894-2",
    "data-name": "Group 71894",
    transform: "translate(-16919.268 1870.375)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71880-2",
    "data-name": "Group 71880",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71879-2",
    "data-name": "Group 71879",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7763-2",
    "data-name": "Path 7763",
    d: "M272.053,68.42a65.7,65.7,0,1,1-65.7-65.7,65.7,65.7,0,0,1,65.7,65.7",
    transform: "translate(-104.922 -2.03)",
    fill: "rgba(19,15,48,0.06)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7764-2",
    "data-name": "Path 7764",
    d: "M293.682,101.219a54.527,54.527,0,1,1-54.527-54.527,54.527,54.527,0,0,1,54.527,54.527",
    transform: "translate(-137.722 -34.83)",
    fill: "rgba(19,15,48,0.08)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7765-2",
    "data-name": "Path 7765",
    d: "M293.84,493.057h-.009l-.474-.018a.236.236,0,1,1,.02-.472l.471.019a.236.236,0,0,1-.008.473",
    transform: "translate(-218.66 -367.427)",
    fill: "#87b1e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7767-2",
    "data-name": "Path 7767",
    d: "M799.218,452.866h0l-.474-.007a.236.236,0,0,1,0-.473h0l.471.007a.236.236,0,0,1,0,.473",
    transform: "translate(-595.644 -337.455)",
    fill: "#87b1e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7768-2",
    "data-name": "Path 7768",
    d: "M632.27,270.225a1.762,1.762,0,1,1,1.762-1.762,1.764,1.764,0,0,1-1.762,1.762m0-2.8a1.04,1.04,0,1,0,1.04,1.04,1.041,1.041,0,0,0-1.04-1.04",
    transform: "translate(-470.324 -198.944)",
    fill: "#87b1e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7769-2",
    "data-name": "Path 7769",
    d: "M165.889,126.539a1.765,1.765,0,1,1,1.765-1.765,1.767,1.767,0,0,1-1.765,1.765m0-2.806a1.041,1.041,0,1,0,1.041,1.041,1.042,1.042,0,0,0-1.041-1.041",
    transform: "translate(-122.428 -91.758)",
    fill: "#87b1e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7770-2",
    "data-name": "Path 7770",
    d: "M84.243,429.813h-.929V428.5a.264.264,0,0,0-.528,0v1.311h-.929a.264.264,0,0,0,0,.527h.929v1.311a.264.264,0,0,0,.528,0V430.34h.929a.264.264,0,1,0,0-.527",
    transform: "translate(-60.864 -319.442)",
    fill: "#87b1e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7771-2",
    "data-name": "Path 7771",
    d: "M580.14,6.884h-1.395V4.917a.4.4,0,0,0-.792,0V6.884h-1.395a.4.4,0,1,0,0,.792h1.395V9.643a.4.4,0,0,0,.792,0V7.676h1.395a.4.4,0,0,0,0-.792",
    transform: "translate(-429.785 -3.372)",
    fill: "#87b1e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7772-2",
    "data-name": "Path 7772",
    d: "M190.136,40.326h-6.361a.876.876,0,1,1,0-1.751h6.361a.876.876,0,1,1,0,1.751",
    transform: "translate(-160.63 -17.475)",
    fill: "#87b1e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7773-2",
    "data-name": "Path 7773",
    d: "M222.349,8.112a.876.876,0,0,1-.876-.876V.876a.876.876,0,0,1,1.751,0V7.236a.876.876,0,0,1-.876.876",
    transform: "translate(-184.769 6.666)",
    fill: "#87b1e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7774-2",
    "data-name": "Path 7774",
    d: "M199.442,17.419a.873.873,0,0,1-.619-.256l-4.37-4.37a.876.876,0,1,1,1.238-1.238l4.37,4.369a.876.876,0,0,1-.619,1.495",
    transform: "translate(-167.698 -0.405)",
    fill: "#87b1e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7776-2",
    "data-name": "Path 7776",
    d: "M180.359,480.787v1.394l-2.09-.7Z",
    transform: "translate(-132.979 -358.641)",
    fill: "#1a2b5b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71881-2",
    "data-name": "Group 71881",
    transform: "translate(37.248 22.926)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27567-2",
    "data-name": "Rectangle 27567",
    width: 135.265,
    height: 79.096,
    rx: 4,
    transform: "translate(0 0)",
    fill: "#14244d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27568-2",
    "data-name": "Rectangle 27568",
    width: 125.521,
    height: 71.072,
    rx: 1,
    transform: "translate(5.158 4.012)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_71884-2",
    "data-name": "Group 71884",
    transform: "translate(43.123 28.49)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27569-2",
    "data-name": "Rectangle 27569",
    width: 123.998,
    height: 8.023,
    fill: "#ffcfd3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_71883-2",
    "data-name": "Group 71883"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71882-2",
    "data-name": "Group 71882",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7777-2",
    "data-name": "Path 7777",
    d: "M485.115,10.512a1.989,1.989,0,1,0-1.989,1.989,1.989,1.989,0,0,0,1.989-1.989",
    transform: "translate(-366.971 -6.501)",
    fill: "#e0777f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7778-2",
    "data-name": "Path 7778",
    d: "M461.361,10.512a1.989,1.989,0,1,0-1.989,1.989,1.99,1.99,0,0,0,1.989-1.989",
    transform: "translate(-348.854 -6.501)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7779-2",
    "data-name": "Path 7779",
    d: "M67.04,13.053H22.727a.361.361,0,0,1-.361-.361V9.933a.361.361,0,0,1,.361-.361H67.04a.361.361,0,0,1,.361.361v2.759a.361.361,0,0,1-.361.361",
    transform: "translate(-17.059 -7.301)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7780-2",
    "data-name": "Path 7780",
    d: "M332.887,92.7H291.333a1.741,1.741,0,0,1,0-3.481h41.554a1.741,1.741,0,1,1,0,3.481",
    transform: "translate(-220.878 -66.905)",
    fill: "#d6d6d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7781-2",
    "data-name": "Path 7781",
    d: "M332.887,122.04H291.333a1.741,1.741,0,0,1,0-3.481h41.554a1.741,1.741,0,1,1,0,3.481",
    transform: "translate(-220.878 -89.285)",
    fill: "#d6d6d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7782-2",
    "data-name": "Path 7782",
    d: "M314.9,151.383H291.334a1.741,1.741,0,0,1,0-3.481H314.9a1.741,1.741,0,1,1,0,3.481",
    transform: "translate(-220.879 -111.666)",
    fill: "#d6d6d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7783-2",
    "data-name": "Path 7783",
    d: "M74.352,108.384H19.1a1.4,1.4,0,0,1-1.4-1.4V54.155a1.4,1.4,0,0,1,1.4-1.4H74.352a1.4,1.4,0,0,1,1.4,1.4V106.98a1.4,1.4,0,0,1-1.4,1.4",
    transform: "translate(-13.494 -41.234)",
    fill: "#cfd7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7784-2",
    "data-name": "Path 7784",
    d: "M87.667,99.293l5.412.868a.407.407,0,0,0,.433-.23l2.409-5.169a.407.407,0,0,0-.159-.52L84.835,87.654a.405.405,0,0,0-.6.245c-.355,1.4-1.628,5.069-5.242,5.126C75.376,92.968,74.1,89.3,73.748,87.9a.405.405,0,0,0-.6-.245L62.217,94.242a.407.407,0,0,0-.159.52l2.409,5.169a.407.407,0,0,0,.433.23l5.412-.868a.405.405,0,0,1,.382.147c.74.924,3.978,5.076,3.779,6.717S66.241,121.75,64.446,124.85a.406.406,0,0,0,.353.609H93.181a.406.406,0,0,0,.353-.609c-1.8-3.1-9.828-17.048-10.027-18.693s3.038-5.793,3.779-6.717a.4.4,0,0,1,.382-.147",
    transform: "translate(-47.304 -66.81)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7785-2",
    "data-name": "Path 7785",
    d: "M334.5,233.854H293.719a1.506,1.506,0,0,1-1.506-1.506V228a1.506,1.506,0,0,1,1.506-1.506H334.5A1.506,1.506,0,0,1,336,228v4.345a1.506,1.506,0,0,1-1.506,1.506",
    transform: "translate(-222.876 -172.754)",
    fill: "#95a9f0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71926",
    "data-name": "Group 71926",
    transform: "translate(-2394.683 -685.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7847",
    "data-name": "Path 7847",
    d: "M330.876,132.533a21.952,21.952,0,1,1-21.952-21.952,21.952,21.952,0,0,1,21.952,21.952",
    transform: "translate(-18040.959 5373.415)",
    fill: "#57cab8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7848",
    "data-name": "Path 7848",
    d: "M308.967,147.653l-9.138-9.9,4.223-3.9,4.622,5.007,11.479-14.227,4.473,3.608Z",
    transform: "translate(-18044.264 5369.804)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_71921",
    "data-name": "Group 71921",
    transform: "translate(-20129.719 4845.124)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71920",
    "data-name": "Group 71920",
    transform: "translate(3)",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7849",
    "data-name": "Path 7849",
    d: "M6.264.165,7.89,3.459a.3.3,0,0,0,.222.161l3.635.528a.3.3,0,0,1,.163.5L9.28,7.215a.3.3,0,0,0-.085.261l.621,3.62a.3.3,0,0,1-.428.311L6.137,9.7a.3.3,0,0,0-.274,0L2.611,11.407a.3.3,0,0,1-.428-.311L2.8,7.476a.3.3,0,0,0-.085-.261L.089,4.651a.3.3,0,0,1,.163-.5L3.888,3.62a.3.3,0,0,0,.222-.161L5.736.165a.3.3,0,0,1,.529,0",
    transform: "translate(0 0)",
    fill: "#fbc343"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71922",
    "data-name": "Group 71922",
    transform: "translate(-20112.719 4845.124)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71920-2",
    "data-name": "Group 71920",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7849-2",
    "data-name": "Path 7849",
    d: "M6.264.165,7.89,3.459a.3.3,0,0,0,.222.161l3.635.528a.3.3,0,0,1,.163.5L9.28,7.215a.3.3,0,0,0-.085.261l.621,3.62a.3.3,0,0,1-.428.311L6.137,9.7a.3.3,0,0,0-.274,0L2.611,11.407a.3.3,0,0,1-.428-.311L2.8,7.476a.3.3,0,0,0-.085-.261L.089,4.651a.3.3,0,0,1,.163-.5L3.888,3.62a.3.3,0,0,0,.222-.161L5.736.165a.3.3,0,0,1,.529,0",
    transform: "translate(0 0)",
    fill: "#fbc343"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71923",
    "data-name": "Group 71923",
    transform: "translate(-20098.719 4845.124)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71920-3",
    "data-name": "Group 71920",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7849-3",
    "data-name": "Path 7849",
    d: "M6.264.165,7.89,3.459a.3.3,0,0,0,.222.161l3.635.528a.3.3,0,0,1,.163.5L9.28,7.215a.3.3,0,0,0-.085.261l.621,3.62a.3.3,0,0,1-.428.311L6.137,9.7a.3.3,0,0,0-.274,0L2.611,11.407a.3.3,0,0,1-.428-.311L2.8,7.476a.3.3,0,0,0-.085-.261L.089,4.651a.3.3,0,0,1,.163-.5L3.888,3.62a.3.3,0,0,0,.222-.161L5.736.165a.3.3,0,0,1,.529,0",
    transform: "translate(0 0)",
    fill: "#fbc343"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71925",
    "data-name": "Group 71925",
    transform: "translate(-20257.238 4848.341)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71924",
    "data-name": "Group 71924",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7850",
    "data-name": "Path 7850",
    d: "M175.372,133.522a5.243,5.243,0,0,1,6.735,1.314,5.443,5.443,0,0,1,4.247.464c2.479,1.431,4,5.439,1.991,7.615-.489,2.24-1.385,4.009-3.612,4.037-1.315,2.418-5.412,3.124-7.781.857-2.067.654-4.278-.529-5.714-2.172-.339-.388-.625-1-.754-1.079,0,0-5.333-.981-4.849-6.146.507-5.405,6.123-9.134,9.738-4.891",
    transform: "translate(-152.217 -120.981)",
    fill: "#1b227a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7851",
    "data-name": "Path 7851",
    d: "M48.479,949.424a30.226,30.226,0,0,1-.628,4.69c-.031.12-.414.593-.449.716a7.609,7.609,0,0,0,4.22,5.147c-.52-1.358-1.489-2.867-1.428-3.193a41.713,41.713,0,0,1,1.393-5.9c-1.347.022-1.923-.758-3.108-1.459",
    transform: "translate(-4.956 -872.244)",
    fill: "#f8a492"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7852",
    "data-name": "Path 7852",
    d: "M8.288,536.217,0,542.928s4.176,4.117,5.742,5.648,9.448,7.045,9.586,7.4a12.144,12.144,0,0,0-.515,1.96c-.346,2.832-.736,8.339-.853,13.062.892.935,2.823,1.157,3.978,1.45,2.839-5.8,3.865-16.942,3.852-18.28-.021-2.179-13.5-17.948-13.5-17.948",
    transform: "translate(28.728 -492.627)",
    fill: "#355389"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7853",
    "data-name": "Path 7853",
    d: "M390.955,672.91a39.581,39.581,0,0,1,3.97,5.157,15.611,15.611,0,0,1,2.277-2.492,29.29,29.29,0,0,1-3.838-4.584c-.719-1.706-1.163-1.877-1.163-1.877s-5.281,3.379-5.539,4.036,2.987-1.077,4.294-.24",
    transform: "translate(-378.113 -614.721)",
    fill: "#f8a492"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7854",
    "data-name": "Path 7854",
    d: "M439.038,661.219c.444-.1-.495-2.087-.7-2.546-.233-.516-.57-.608-.649-.609-.214,0-6.084,3.751-6.982,4.813a1.4,1.4,0,0,0-.165.32c-.339,1.287,4.951.263,5.6-.417a4.386,4.386,0,0,1,2.9-1.56",
    transform: "translate(-423.635 -604.569)",
    fill: "#184655"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7855",
    "data-name": "Path 7855",
    d: "M167.4,522.322l-7.887-3.341c.029.013-.037.312-.047.334-1.173,2.674-3.927,2.593-5.208,6.931-1.013,3.43-.448,14.913-.448,14.913s-3.414-2.489-7-5.144c-.327-.242-2.891,2.611-2.891,2.611,4.878,8.174,12.422,11.323,13.377,10.946,3.261-1.288,8.106-23.215,8.1-23.213.629-1.313,2-4.036,2-4.036",
    transform: "translate(-128.581 -476.792)",
    fill: "#466eb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7856",
    "data-name": "Path 7856",
    d: "M316.787,241.1s-8.973-1.8-10.97-2.072-8.963-2.51-9.23-2.606-1.356-3.731-1.737-3.454.65,1.828.169,2.06-4.686-1.488-4.7-1.137c-.035.657,2.533,1.156,2.461,1.46s-2.63-.778-2.926-.312,2.518.789,2.576,1.04-2.692.061-2.527.594c.089.289,2.45.108,2.36.454s-1.879.774-1.745,1.1,1.457-.565,2.394-.367,1.721-.159,3.115.607,5.987,4.061,9.2,4.627,10.318,1.834,10.318,1.834Z",
    transform: "translate(-289.828 -214.012)",
    fill: "#f8a492"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7857",
    "data-name": "Path 7857",
    d: "M15.538,26.118s3.4-8.5,4.255-10.321,2.792-8.879,2.858-9.155S20.266,3.468,20.707,3.3s1.176,1.543,1.633,1.267S23.652-.171,23.957,0c.569.329-.416,2.753-.121,2.859S24.62.236,25.172.242s-.714,2.54-.536,2.726S26.157.747,26.514,1.176c.193.233-1.248,2.111-.909,2.225s1.675-1.152,1.872-.863-1.269.911-1.615,1.8S24.788,5.7,24.669,7.283s.132,7.234-1.151,10.237-4.1,9.645-4.1,9.645Z",
    transform: "translate(21.762 0)",
    fill: "#f8a492"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7858",
    "data-name": "Path 7858",
    d: "M108.591,291.439c.109-1.578.279-5.834.206-6.357a27.467,27.467,0,0,1,2.425-4.776s-2.285-2.652-3.959-2.613a14.367,14.367,0,0,1-3.074,3.1,3.181,3.181,0,0,1-.663.214,52.014,52.014,0,0,0-6.57.173l.542,7.2c.244.411.616,8.692,1.116,9.369s7.712,3.711,8.895,2.9c.047-.032.864-6.021,1.085-9.211",
    transform: "translate(-68.583 -255.119)",
    fill: "#f47458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7859",
    "data-name": "Path 7859",
    d: "M251.63,318.6a3.59,3.59,0,0,0-1.357-.21c-2.024-.015-5.433-.067-5.433-.067s-.79,4.342-.108,5.377c0,0,5.333.776,5.186,1.234Z",
    transform: "translate(-220.983 -292.447)",
    fill: "#f47458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7860",
    "data-name": "Path 7860",
    d: "M181.394,271.178a20.032,20.032,0,0,1,.4,3.482c-.083.987.393,4.16,2.39,4.151s.34-4.043.142-5.008a38.613,38.613,0,0,1-.271-3.954Z",
    transform: "translate(-149.389 -247.912)",
    fill: "#f8a492"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7861",
    "data-name": "Path 7861",
    d: "M197,271.348c-.039-.818-.056-1.5-.056-1.5l-2.665,1.329s.1.51.2,1.161a2.292,2.292,0,0,0,2.52-.99",
    transform: "translate(-162.278 -247.911)",
    fill: "#f47458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7862",
    "data-name": "Path 7862",
    d: "M183.605,197.58a3.431,3.431,0,0,0-1.391,1.909c-.365,1.3.1,4.642,2.771,5.423s3.8-1.879,3.233-3.945-1.789-4.677-4.613-3.387",
    transform: "translate(-152.646 -181.203)",
    fill: "#f8a492"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7863",
    "data-name": "Path 7863",
    d: "M180.921,221.215c-.047.557-.336.985-.647.956s-.524-.5-.477-1.06.336-.985.647-.956.524.5.477,1.06",
    transform: "translate(-145.024 -202.256)",
    fill: "#f8a492"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7864",
    "data-name": "Path 7864",
    d: "M41.07,1007.225c-.221-.416-1.734,1.207-2.1,1.544a.946.946,0,0,0-.376.822c.055.211,5.028,5.158,6.377,5.752a.7.7,0,0,0,.447-.014c.662-.374-1.03-4.74-2.056-5.51a5.743,5.743,0,0,1-2.295-2.594",
    transform: "translate(1.812 -925.284)",
    fill: "#184655"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7865",
    "data-name": "Path 7865",
    d: "M239.583,199.35s-.447,3.737-1.6,4.422-.649,2.336-.649,2.336-1.085-3.834-.184-5.078a5.048,5.048,0,0,1,2.428-1.679",
    transform: "translate(-208.313 -183.144)",
    fill: "#13375b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7866",
    "data-name": "Path 7866",
    d: "M246.349,253.937c.318.483.322,1.057.01,1.281s-.823.014-1.141-.469-.322-1.057-.01-1.281.823-.014,1.141.469",
    transform: "translate(-215.985 -232.781)",
    fill: "#f8a492"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27582",
    "data-name": "Rectangle 27582",
    width: 167,
    height: 24,
    transform: "translate(-19969.336 4558.569)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Approve_the_preview",
    "data-name": "Approve the preview",
    transform: "translate(-19962.336 4572.569)",
    fill: "#130f30",
    fontSize: 14,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Approve the preview")), /*#__PURE__*/React.createElement("text", {
    id: "Go_live",
    "data-name": "Go live",
    transform: "translate(-20163.93 4773.318)",
    fill: "#130f30",
    fontSize: 14,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Go live")), /*#__PURE__*/React.createElement("g", {
    id: "Group_71930",
    "data-name": "Group 71930",
    transform: "translate(-2329.336 -628.431)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7867",
    "data-name": "Path 7867",
    d: "M317.57,125.88a15.3,15.3,0,1,1-15.3-15.3,15.3,15.3,0,0,1,15.3,15.3",
    transform: "translate(-18062.402 5028.071)",
    fill: "#ff5242"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_1",
    "data-name": 1,
    transform: "translate(-17764.098 5161.951)",
    fill: "#fff",
    fontSize: 20,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71931",
    "data-name": "Group 71931",
    transform: "translate(-2083.336 -533.431)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7867-2",
    "data-name": "Path 7867",
    d: "M317.57,125.88a15.3,15.3,0,1,1-15.3-15.3,15.3,15.3,0,0,1,15.3,15.3",
    transform: "translate(-18062.402 5028.071)",
    fill: "#ff5242"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_2",
    "data-name": 2,
    transform: "translate(-17766.133 5160.951)",
    fill: "#fff",
    fontSize: 20,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2"))), /*#__PURE__*/React.createElement("path", {
    id: "Path_7888",
    "data-name": "Path 7888",
    d: "M301.982,118.087a7.506,7.506,0,1,1-7.505-7.506,7.506,7.506,0,0,1,7.505,7.506",
    transform: "translate(-20449.736 4432.977)",
    fill: "#57cab8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7923",
    "data-name": "Path 7923",
    d: "M301.982,118.087a7.506,7.506,0,1,1-7.505-7.506,7.506,7.506,0,0,1,7.505,7.506",
    transform: "translate(-20448.736 4453.482)",
    fill: "#57cab8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7889",
    "data-name": "Path 7889",
    d: "M302.953,132.506l-3.124-3.385,1.444-1.333,1.58,1.712,3.925-4.864,1.529,1.234Z",
    transform: "translate(-20459.328 4422.493)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7924",
    "data-name": "Path 7924",
    d: "M302.953,132.506l-3.124-3.385,1.444-1.333,1.58,1.712,3.925-4.864,1.529,1.234Z",
    transform: "translate(-20458.328 4442.999)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_71944",
    "data-name": "Group 71944",
    transform: "translate(-19969.336 4652.889)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7738",
    "data-name": "Path 7738",
    d: "M17.125,37.06s-1.116,5.542-1.408,6.528-1.739,7.248-3.111,7.139-8.883-6.38-8.883-6.38L4.787,42.22,11.4,45.371a85.071,85.071,0,0,1,1.122-8.862",
    transform: "translate(7.583 -11.288)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_71876",
    "data-name": "Group 71876",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71875",
    "data-name": "Group 71875",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71874",
    "data-name": "Group 71874",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71873",
    "data-name": "Group 71873",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7739",
    "data-name": "Path 7739",
    d: "M27.112,12.412a10.616,10.616,0,0,0,.466,2.059.865.865,0,0,1-.721.346",
    transform: "translate(-9.034 -4.175)",
    fill: "#ffb392"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_71872",
    "data-name": "Group 71872",
    transform: "translate(0.609 103.578)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71871",
    "data-name": "Group 71871"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71870",
    "data-name": "Group 71870",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7740",
    "data-name": "Path 7740",
    d: "M32.576,157.511c0,.788-7.087,1.425-15.83,1.425S.917,158.3.917,157.511s7.087-1.425,15.83-1.425,15.83.638,15.83,1.425",
    transform: "translate(-0.917 -156.086)",
    fill: "#a1d7e5"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_7741",
    "data-name": "Path 7741",
    d: "M28.265,45.659a4.764,4.764,0,0,0,1.514-1.35l1.3-1.545a1.285,1.285,0,0,0,.368-.69c-.725-.059-1.193.883-1.918.939a15.154,15.154,0,0,1,1.441-3.423,1.053,1.053,0,0,0,.208-.853,5.532,5.532,0,0,0-2.015,1.472A10.758,10.758,0,0,0,28.069,41.6a14.957,14.957,0,0,0-1.954,4.8",
    transform: "translate(-8.785 -13.031)",
    fill: "#f2a181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7742",
    "data-name": "Path 7742",
    d: "M19.411,64.494l-7.775-6.56S8.017,62.841,9.38,67.576a43.511,43.511,0,0,0,1.877,4.587c.341,1.032,2.682,15.64,2.506,16.709s-1.431,4.056-1.911,7.2c-.577,3.78-.478,16.095-.926,19.36s2.568,3.818,2.733,2.713c1.417-9.442,5.161-24.155,5.684-28.875s.311-13.364.065-24.774",
    transform: "translate(-3.052 -19.489)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7743",
    "data-name": "Path 7743",
    d: "M22.971,81.835,19.59,89.594a17.375,17.375,0,0,1,2.358,8.132c.057,1.5-.075,3-.034,4.494a1.523,1.523,0,0,0,.046.326c.453-2.22.791-4.049.923-5.24a142.354,142.354,0,0,0,.255-15.478,1.41,1.41,0,0,0-.167.008",
    transform: "translate(-6.59 -27.527)",
    fill: "#f2a181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7744",
    "data-name": "Path 7744",
    d: "M14.338,143.733a19.983,19.983,0,0,0-.529,3.862,6,6,0,0,0,1.613,2.165c.753.482,2.42,1.054,2.553,1.262a.518.518,0,0,1-.1.7,3.454,3.454,0,0,1-2.376.6c-2.26-.374-2.494-1.373-3.81-1.533-.228-.027-.649.309-1.277-.013a1.5,1.5,0,0,1-.881-1.45,6.484,6.484,0,0,1,1-2.419,19.69,19.69,0,0,0,.643-3.892",
    transform: "translate(-3.205 -48.111)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7745",
    "data-name": "Path 7745",
    d: "M17.884,154.141c.165-.282.206-.709.053-.813a13.238,13.238,0,0,0-1.407-.847c-.438-.2-1.133-.38-.889-.247s-.206.626-.616.6c-1.417-.086-2.461-1.028-3.269-1.23a2.771,2.771,0,0,1-1.7-1.889,5.424,5.424,0,0,0-.836,1.6,2.787,2.787,0,0,0-.173,1.218,2.833,2.833,0,0,1,.129,1.161,2.222,2.222,0,0,0,.837.3,3.3,3.3,0,0,0,.9.013l.1-.731a3.3,3.3,0,0,1,.721.071,3.907,3.907,0,0,1,1.1.514c.161.193.291.545.505.653a4.509,4.509,0,0,0,1.858.463c1.519.089,2.406-.352,2.687-.834",
    transform: "translate(-3.034 -50.365)",
    fill: "#1b227a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7746",
    "data-name": "Path 7746",
    d: "M31.358,122.738c-.168-.184-1.969-.478-2.814-.83a4.859,4.859,0,0,1-1.969-1.877,20.244,20.244,0,0,1-.122-3.759c.169-6.723,1.41-23.152,1.591-27.087.312-6.838-.575-13.9-3.207-24.875l-9.8-7.519s-2.744,5.1-1.826,9.978c.533,2.83,2.88,3.265,3.277,4.365s6.325,18.831,6.325,18.831A33.365,33.365,0,0,0,21.6,98c-.057,3.585,1.569,14.4,1.87,18.518a13.505,13.505,0,0,1-.063,3.346c-.291.752-1.031,1.634-.994,2.583a1.458,1.458,0,0,0,1.113,1.29c.695.216,1.082-.186,1.32-.2,1.381-.057,1.763.893,4.149.892a3.774,3.774,0,0,0,2.367-.984.5.5,0,0,0,0-.707",
    transform: "translate(-4.382 -19.104)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7747",
    "data-name": "Path 7747",
    d: "M36.182,155.869c.13-.306.113-.734-.06-.812a13.669,13.669,0,0,0-1.571-.607c-.481-.127-1.223-.19-.952-.1s-.123.654-.551.7c-1.474.146-2.685-.614-3.546-.682a2.262,2.262,0,0,1-1.783-1.589,5.694,5.694,0,0,0-.88,1.714,2.685,2.685,0,0,0-.006,1.232,2.694,2.694,0,0,1,.3,1.127,2.355,2.355,0,0,0,.907.161,3.594,3.594,0,0,0,.932-.135v-.739a3.585,3.585,0,0,1,.753-.048,2.5,2.5,0,0,1,1.216.43c.2.152.415.409.654.469a5,5,0,0,0,1.935.146c1.58-.161,2.432-.742,2.654-1.264",
    transform: "translate(-9.002 -51.393)",
    fill: "#1b227a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7748",
    "data-name": "Path 7748",
    d: "M11.693,56.316c-.665.73-3.035,4.679-3.06,7.893a14.833,14.833,0,0,0,1.221,5.945c.607,1.757,1.735,3.327,1.735,3.649s1.767.543,5.515.307c6.925-.436,9.469-1.735,9.469-1.735a54.233,54.233,0,0,0-.484-9.13c-.337-2.968-2.865-7.669-2.865-7.669",
    transform: "translate(-2.904 -18.696)",
    fill: "#466eb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7749",
    "data-name": "Path 7749",
    d: "M3.723,37.06S4.839,42.6,5.131,43.588s1.739,7.248,3.111,7.139,8.882-6.38,8.882-6.38L16.061,42.22,9.449,45.371a85.075,85.075,0,0,0-1.121-8.862",
    transform: "translate(-1.252 -12.282)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7750",
    "data-name": "Path 7750",
    d: "M7.575,42.481c.7,2.474,2.134,5.081,2.564,7,.086.386,4.665-1.279,4.674-3",
    transform: "translate(-2.548 -14.291)",
    fill: "#f2a181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7751",
    "data-name": "Path 7751",
    d: "M8.063,25.765a8.123,8.123,0,0,0-3.3,1.084c-2.835,2.169-.641,10.042-.641,10.042s-.14.421,1.763.314a13.7,13.7,0,0,0,3.429-.648L8.76,30.106",
    transform: "translate(-1.113 -8.667)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7752",
    "data-name": "Path 7752",
    d: "M6.675,32.482s-.24,4.629.6,6.964a7.525,7.525,0,0,0,1.553-.2Z",
    transform: "translate(-2.235 -10.927)",
    fill: "#b03d44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7753",
    "data-name": "Path 7753",
    d: "M21.276,3.653c1.321,1.713,1.06,4.122.734,6.26q-.247,1.622-.494,3.244a2.171,2.171,0,0,1-.583,1.406,2.169,2.169,0,0,1-1.5.307l.016,2.684q-2.3.056-4.594.019a4.43,4.43,0,0,0-.4-1.823c-.749-.015-1.25-.766-1.543-1.455a21.16,21.16,0,0,1-.822-2.456A13.554,13.554,0,0,1,11.44,8.47a4.871,4.871,0,0,1,.972-3.223,5.863,5.863,0,0,1,1.866-1.394,3.645,3.645,0,0,1,3.07-.453",
    transform: "translate(-3.848 -1.08)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7754",
    "data-name": "Path 7754",
    d: "M18.418,10.732a2.794,2.794,0,0,1,.127-2.006,1.317,1.317,0,0,1,.4-.51.852.852,0,0,1,.818-.085.911.911,0,0,1,.411.384,11.737,11.737,0,0,0,.287-3.751A4.878,4.878,0,0,0,17.37.515C14.127-.817,9.467.5,8.15,3.683a7.877,7.877,0,0,0,1.413,7.89c1.686,1.784,4.112,2.047,6.349,1.679,1.145-.188,2.913-.075,3.505-1.632a.174.174,0,0,0-.179-.231c-.465.036-.788-.49-.822-.657",
    transform: "translate(-2.574 0)",
    fill: "#1b227a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7755",
    "data-name": "Path 7755",
    d: "M22.591,6.826c.121.189.092.443.205.636a1.494,1.494,0,0,0,.784.6c.55.255.421,1.056.405,1.415.415-.276.482-1.027.583-1.409.112-.429.184-.869.309-1.294a6.567,6.567,0,0,0,.371-1.239A5.088,5.088,0,0,0,23.3,1.42a2.711,2.711,0,0,0-3.035.036,2.371,2.371,0,0,0-.866,1.1.73.73,0,0,0-.034.591",
    transform: "translate(-6.497 -0.327)",
    fill: "#1b227a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7756",
    "data-name": "Path 7756",
    d: "M13.145,24.959c.078-.524.22-1.135.707-1.342a1.554,1.554,0,0,1,.431-.092,35.642,35.642,0,0,1,4.5-.212,4.178,4.178,0,0,1,1.821.319,4.479,4.479,0,0,1,1.773,2.255",
    transform: "translate(-4.422 -7.841)",
    fill: "#b03d44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7757",
    "data-name": "Path 7757",
    d: "M23.626,44.621a12.527,12.527,0,0,1-.864-1.019,15.975,15.975,0,0,1-.635-5.128c.153-.94.985-1.447,1.361-3.54a7.741,7.741,0,0,0-1.24-5.691c-.874-1.269-.356-1.262-.654-2.818a1.486,1.486,0,0,0-.309-.774,7.443,7.443,0,0,0-1.747-.828,27.545,27.545,0,0,0-6.312.025,21.037,21.037,0,0,0-3.621.459c-1.32.291-2.469.641-2.741,2.432a18.039,18.039,0,0,0,.775,8.2C8.2,37.679,11.531,43.7,10.7,44.87a3.986,3.986,0,0,0-.718,1.106c-.209,1.218,2.542,1.646,3.72,1.743a46.019,46.019,0,0,0,5.651-.036c1.362-.064,4.343-.54,4.554-2.223a1.214,1.214,0,0,0-.285-.838",
    transform: "translate(-2.249 -8.288)",
    fill: "#f47458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7758",
    "data-name": "Path 7758",
    d: "M29.427,39.307a4.85,4.85,0,0,1-.362,1.4,3.769,3.769,0,0,1-2.475.112,35.938,35.938,0,0,0-1.118-4.735s3.954,2.765,3.955,3.218",
    transform: "translate(-8.569 -12.14)",
    fill: "#b03d44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7759",
    "data-name": "Path 7759",
    d: "M22.591,24.645c1.169.062,4.57-.536,6.46,1.442,1.584,1.656,2.491,6,3.129,7.76-1.587,1.617-3.115,2.921-5.519,2.4-.091-.068-1.283-3.822-2.152-4.155",
    transform: "translate(-7.599 -8.278)",
    fill: "#f47458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7760",
    "data-name": "Path 7760",
    d: "M27.2,74.4s.772,18.55.631,19.9-1.646,26.964-1.646,26.964a13.962,13.962,0,0,1-4.941,0s-2.388-19.945,0-26.16l-1.061-5.955s.158,4.43,0,5.331-4.935,26.153-4.935,26.153-3.159-.084-4.6-1.35c0,0-.45-17.543,2.842-24.923l-3.012-19.3,1.735-4.912Z",
    transform: "translate(-3.523 -23.596)",
    fill: "#466eb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7761",
    "data-name": "Path 7761",
    d: "M21.745,90.493c-.441-2.853-3.163-12.972-3.28-13.216-1.488-1.153-2.848-2.17-3.343-3.132.814,2.44,2.379,2.566,2.965,3.829,1.448,3.118.342,2.43,3.722,12.876",
    transform: "translate(-5.087 -24.943)",
    fill: "#170d54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7762",
    "data-name": "Path 7762",
    d: "M3.366,22.052c-.07.987.132,1.973.148,2.962a3.587,3.587,0,0,1-.923,2.728A1.757,1.757,0,0,1,0,27.6a3.908,3.908,0,0,0,2.837,2.041,6,6,0,0,0,3.532-.544,8.262,8.262,0,0,0,4.778-7.623c-.074-2.648-2.086-5.208-4.895-3.816a5.409,5.409,0,0,0-2.885,4.4",
    transform: "translate(0 -5.807)",
    fill: "#1b227a"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71947",
    "data-name": "Group 71947",
    transform: "translate(-19948.361 4647.925)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71946",
    "data-name": "Group 71946",
    transform: "translate(0)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7890",
    "data-name": "Path 7890",
    d: "M295.957,712.957s-.322,2.256-.362,2.595-3.581-.2-3.581-.2l-.287-2.686s3.788-.028,4.23.29",
    transform: "translate(-286.679 -609.607)",
    fill: "#5c544d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7891",
    "data-name": "Path 7891",
    d: "M255.935,729.735a9.6,9.6,0,0,0,2.207,1.952c1.085.593,2.791.827,3.432,1.441.463.443,1.687,2.349-2.82,2.31s-6.68.269-7.163-.462.7-5.394.7-5.394a9.456,9.456,0,0,0,3.645.153",
    transform: "translate(-246.981 -624.077)",
    fill: "#3c4145"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7892",
    "data-name": "Path 7892",
    d: "M120.5,712.957s-.322,2.256-.362,2.595-3.581-.2-3.581-.2l-.287-2.686s3.788-.028,4.23.29",
    transform: "translate(-85.848 -609.607)",
    fill: "#5c544d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7893",
    "data-name": "Path 7893",
    d: "M66.081,729.735a9.594,9.594,0,0,0,2.207,1.952c1.085.593,5.078,1.079,5.72,1.693.463.443,1.234,2.225-5.108,2.058-4.505-.118-6.68.269-7.163-.462s.7-5.394.7-5.394a8.58,8.58,0,0,0,3.645.153",
    transform: "translate(-31.754 -624.077)",
    fill: "#3c4145"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7894",
    "data-name": "Path 7894",
    d: "M221.309,311.911a33.359,33.359,0,0,0-1.636,10.423c.248,4.824-.975,10.1-1.474,15.144-.557,5.618-2.838,18.92-2.92,21.925s.354,12.6.354,12.6l4.565.105s3.834-23.254,4.827-25.626,5.917-19.288,6.083-21.186-9.8-13.386-9.8-13.386",
    transform: "translate(-210.772 -266.805)",
    fill: "#d06055"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7895",
    "data-name": "Path 7895",
    d: "M131.193,309.084s2.508,13.223,2.839,16.176.552,14.29.717,16.135,1.1,24.15,1.986,26.892H130.9s-4.48-16.215-4.48-23.886-3.461-16.678-5.7-21.74-7.348-5.182-8.721-14.573c0,0,17.331-1.982,19.19,1",
    transform: "translate(-101.467 -262.982)",
    fill: "#ea7064"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7896",
    "data-name": "Path 7896",
    d: "M178.562,3.807s4.6-1.718,6.721,1.784,1.917,10.512-.4,11.374-5.8.411-6.989-1.78a17.548,17.548,0,0,1-2.207-7.476,4.612,4.612,0,0,1,2.877-3.9",
    transform: "translate(-160.696 -2.896)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7897",
    "data-name": "Path 7897",
    d: "M200.237,70.727a3.862,3.862,0,0,0,.121,1.8c.307.594-5.786.61-5.786.61a40.156,40.156,0,0,0-1.432-5.961c-.938-2.73,7.1,3.552,7.1,3.552",
    transform: "translate(-176.823 -56.874)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7898",
    "data-name": "Path 7898",
    d: "M181.094,10.3s.42.694,2.137.425,3.811-2.553,4.528-2.8.724-.672.724-.672l.449.656.761.048s-.694-2.043.353-2.876S188.959-1.535,183.453.39c0,0-4.228,1.166-4.075,3.571s.769,5.144,1.716,6.342",
    transform: "translate(-164.778 0)",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7899",
    "data-name": "Path 7899",
    d: "M197.484,97.878s-.019-1.135-.534-1.244-5.678-.605-6.31-.357V97.6s1.217.749,6.843.279",
    transform: "translate(-173.588 -82.296)",
    fill: "#e2d2ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7900",
    "data-name": "Path 7900",
    d: "M193.423,38.91c-.1-.4-1.122-1.556-1.515-.322s.593,2.894,1.144,2.752.615-1.408.371-2.43",
    transform: "translate(-169.832 -32.533)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7901",
    "data-name": "Path 7901",
    d: "M82.086,106.1s2.831,1.018,6.11,2.411a6.883,6.883,0,0,1,4.18,5.574c.217,2.211,2.571,13.946,3.012,14.939s5.662,16.944,5.846,17.275-4.261,2.176-4.555,2.029-5.055-14.549-5.533-15.615c0,0-2.74-8.635-2.814-9.922,0,0-.079,3.669-.226,4.7s2.437,21.025,2.363,21.577-11.744,1.253-16.414.738a57.206,57.206,0,0,1-8.44-1.59s3.675-15.78,3.562-17.53c-.246-3.812-1.52-10.992-1.52-10.992l-3.808,7.18,4.875,12.541-1.116,3.812s-9.059-13.689-9.353-14.939.444-2.843.922-3.873,3.618-8.867,4.354-9.97,1.978-5.522,4.983-6.751a46.967,46.967,0,0,1,6.727-1.87Z",
    transform: "translate(-58.19 -90.522)",
    fill: "#323657"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27585",
    "data-name": "Rectangle 27585",
    width: 15.369,
    height: 22.03,
    transform: "translate(30.125 63.01) rotate(-104.382)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27587",
    "data-name": "Rectangle 27587",
    width: 15.369,
    height: 22.03,
    transform: "translate(29.346 62.477) rotate(-104.382)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7902",
    "data-name": "Path 7902",
    d: "M39.526,408.245s.61.985.833,1.267-.547.457-.878.173.045-1.439.045-1.439",
    transform: "translate(5.377 -349.208)",
    fill: "#c98462"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7903",
    "data-name": "Path 7903",
    d: "M46.614,390.394a2.366,2.366,0,0,1-.438-.617s-.107-.449-.2-.764a2.242,2.242,0,0,0-.084-.24,4.332,4.332,0,0,1-.488-1.3c-.094-.608-.36-3.338-.36-3.338l1.653-.416,1.328-.28a27.194,27.194,0,0,1,3.022,3.418,1.483,1.483,0,0,1,.035.161,5.523,5.523,0,0,1-.042,1.138c0,.095-.009,1.044-.23,1.222a.928.928,0,0,1-.876.211,2.216,2.216,0,0,1-1.141.429,1.377,1.377,0,0,1-1.2.222s-.618.383-.981.151",
    transform: "translate(-6.154 -327.991)",
    fill: "#de9d7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7904",
    "data-name": "Path 7904",
    d: "M58.228,301.863s3.788,11.471,4.483,12.674a12.494,12.494,0,0,0,4.555-2.029l-4.158-12.379Z",
    transform: "translate(-24.221 -256.727)",
    fill: "#130f30"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71949",
    "data-name": "Group 71949",
    transform: "translate(-20212.818 4563.62)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71948",
    "data-name": "Group 71948",
    transform: "translate(2.979 -0.995)",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7905",
    "data-name": "Path 7905",
    d: "M4.242,357.68a3.753,3.753,0,0,1,.486,1.286,6.171,6.171,0,0,0,.594,1.519,14.456,14.456,0,0,1,.722,2.532,11.688,11.688,0,0,0-.34,1.7c.058.367.267,1.093-.062,1.141s-.7-.547-.7-.547a.484.484,0,0,1-.248.466.816.816,0,0,1-.828.03s-.2.371-.451.421a1.021,1.021,0,0,1-.824-.111,1,1,0,0,1-.626.2.821.821,0,0,1-.694-.432s-.619.125-.8-.164a2.773,2.773,0,0,1-.223-.859,10,10,0,0,1,.785-4.327,3.834,3.834,0,0,0-.2-3.362Z",
    transform: "translate(-0.19 -304.083)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7906",
    "data-name": "Path 7906",
    d: "M4.837,392.52s.055-2.121-.5-2.572-.622.314-.622.314.076-.756-.534-.859-.636.8-.636.8a.59.59,0,0,0-.741-.464c-.641.12-.488.864-.488.864S.7,389.87.3,390.571a3.125,3.125,0,0,0-.024,2.582s.189.321.8.163a.842.842,0,0,0,1.32.231s.934.514,1.275-.31a.773.773,0,0,0,1.163-.718",
    transform: "translate(0 -331.518)",
    fill: "#db9c7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7907",
    "data-name": "Path 7907",
    d: "M12.046,126.663s-3.631,12.1-4.857,16.564c-.385,1.4-1.316,14.769-1.48,15.307S.939,159.81.939,159.81s.558-16.724.61-17.636,5.081-19.588,6.544-20.255c1.1-.5,1.674-.086,3.055.939a3.232,3.232,0,0,1,.9,3.805",
    transform: "translate(-0.799 -103.618)",
    fill: "#323657"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27588",
    "data-name": "Rectangle 27588",
    width: 9.932,
    height: 0.738,
    transform: "translate(46.654 6.095) rotate(-33.21)",
    fill: "#4da8f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7908",
    "data-name": "Path 7908",
    d: "M343.472,10.924a2.171,2.171,0,0,1-.214.659s-.272.324-.451.567a2.025,2.025,0,0,0-.13.193,3.971,3.971,0,0,1-.687,1.067c-.4.4-1.937,1.678-1.937,1.678l-1.321-1.121-1.371-.615A25.812,25.812,0,0,1,338.453,9.6a1.363,1.363,0,0,1,.1-.114,5.06,5.06,0,0,1,.859-.591c.067-.056.773-.564,1.024-.5a.849.849,0,0,1,.634.529,2.031,2.031,0,0,1,.939.6,1.262,1.262,0,0,1,.817.758s.619.246.647.639",
    transform: "translate(-287.217 -7.141)",
    fill: "#efaa88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7909",
    "data-name": "Path 7909",
    d: "M30.938,709.23s-.331,2.3-.372,2.642-3.682-.2-3.682-.2l-.295-2.735s3.894-.028,4.349.3",
    transform: "translate(-22.637 -603.563)",
    fill: "#424773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7910",
    "data-name": "Path 7910",
    d: "M27.345,725.848a9.828,9.828,0,0,0,2.269,1.987c1.116.6,2.868.842,3.528,1.467.476.451,1.734,2.392-2.9,2.352s-6.867.274-7.363-.47.718-5.493.718-5.493a9.809,9.809,0,0,0,3.747.156",
    transform: "translate(-19.378 -617.831)",
    fill: "#292c47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7911",
    "data-name": "Path 7911",
    d: "M206.426,709.23s-.331,2.3-.372,2.642-3.682-.2-3.682-.2l-.295-2.735s3.894-.028,4.349.3",
    transform: "translate(-172.042 -603.563)",
    fill: "#424773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7912",
    "data-name": "Path 7912",
    d: "M202.833,725.848a9.827,9.827,0,0,0,2.269,1.987c1.115.6,5.221,1.1,5.88,1.723.476.451,1.268,2.266-5.251,2.1-4.632-.12-6.867.274-7.363-.47s.718-5.493.718-5.493a8.906,8.906,0,0,0,3.747.156",
    transform: "translate(-168.783 -617.831)",
    fill: "#292c47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7913",
    "data-name": "Path 7913",
    d: "M30.694,313.79s-3.421,5.435-3.165,10.347-1.24,10.275-1.754,15.407c-.573,5.721-2.917,19.264-3,22.324s.364,12.832.364,12.832l4.693.107s3.941-23.677,4.962-26.093,6.082-19.639,6.253-21.572-8.35-13.352-8.35-13.352",
    transform: "translate(-19.379 -267.151)",
    fill: "#d06055"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7914",
    "data-name": "Path 7914",
    d: "M84.274,309.164s2.578,13.464,2.918,16.471.567,14.55.737,16.429,1.589,24.533,2.041,27.382h-6s-4.605-16.51-4.605-24.322-3.558-16.982-5.854-22.136-7.553-5.276-8.965-14.838c0,0,17.816-2.018,19.727,1.014",
    transform: "translate(-54.953 -261.788)",
    fill: "#ea7064"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7915",
    "data-name": "Path 7915",
    d: "M98.072,3.98s4.591-1.715,6.708,1.78,1.913,10.491-.4,11.352-5.791.41-6.975-1.776a17.513,17.513,0,0,1-2.2-7.461A4.6,4.6,0,0,1,98.072,3.98",
    transform: "translate(-81.049 -3.03)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7916",
    "data-name": "Path 7916",
    d: "M111.371,70.856a3.971,3.971,0,0,0,.125,1.85c.316.611-5.948.626-5.948.626a41.257,41.257,0,0,0-1.473-6.127c-.964-2.806,7.3,3.651,7.3,3.651",
    transform: "translate(-88.54 -56.615)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7917",
    "data-name": "Path 7917",
    d: "M94.4,10.591s.432.713,2.2.436,3.918-2.625,4.654-2.882.744-.691.744-.691l.461.674.783.049s-.714-2.1.363-2.957-1.118-6.8-6.777-4.82c0,0-4.347,1.2-4.189,3.67s.791,5.288,1.764,6.519",
    transform: "translate(-78.861 0)",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7918",
    "data-name": "Path 7918",
    d: "M116.655,97.94s-.02-1.167-.549-1.279-5.837-.622-6.486-.367v1.359s1.251.77,7.035.287",
    transform: "translate(-93.327 -81.921)",
    fill: "#e2d2ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7919",
    "data-name": "Path 7919",
    d: "M145.389,38.94c-.1-.414-1.154-1.6-1.557-.331s.61,2.975,1.176,2.829.632-1.447.382-2.5",
    transform: "translate(-122.375 -32.385)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7920",
    "data-name": "Path 7920",
    d: "M68.706,50.019c-3.64-.48-8.78-1.767-8.78-1.767l-7.035-.287a68.45,68.45,0,0,0-9,2.57c-.241.109-.242,5.76-.9,7.242L45.1,62.225s1.218,8.81,1.471,12.728c.116,1.8-2.511,16.867-2.511,16.867a48.54,48.54,0,0,0,7.617,1.358c4.8.529,16.8-.191,16.873-.758S66.222,71.3,66.116,70.24c-.163-1.633.563-10.312.563-10.312,1.108-.86,10.842-5.378,13.5-7.732.711-.63,3.71-3.551,4.563-4.559a81.894,81.894,0,0,0,5.8-7.293c.342-.376-3.358-2.37-3.687-2.479-.288-.1-4.291,5.217-5.862,6.919a44.051,44.051,0,0,1-3.612,2.877s-6.39,2.491-8.667,2.36",
    transform: "translate(-36.599 -32.235)",
    fill: "#323657"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7921",
    "data-name": "Path 7921",
    d: "M90.521,9.164s-5.854.458-.18,9.229Z",
    transform: "translate(-74.805 -7.802)",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7922",
    "data-name": "Path 7922",
    d: "M370.2,4.362l.48-.733-.884.116Z",
    transform: "translate(-314.835 -3.09)",
    fill: "#dfe1e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71950",
    "data-name": "Group 71950",
    transform: "translate(-20135.57 4567.569)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71865",
    "data-name": "Group 71865",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71864",
    "data-name": "Group 71864",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71863",
    "data-name": "Group 71863",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7669",
    "data-name": "Path 7669",
    d: "M27.334,12.412a10.863,10.863,0,0,1-.477,2.107.885.885,0,0,0,.738.354",
    transform: "translate(-8.981 -3.983)",
    fill: "#ffb392"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_71862",
    "data-name": "Group 71862",
    transform: "translate(3.831 105.994)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71861",
    "data-name": "Group 71861"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71860",
    "data-name": "Group 71860",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7670",
    "data-name": "Path 7670",
    d: "M.917,157.545c0,.806,7.253,1.459,16.2,1.459s16.2-.653,16.2-1.459-7.253-1.459-16.2-1.459-16.2.653-16.2,1.459",
    transform: "translate(-0.917 -156.086)",
    fill: "#a1d7e5"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_7671",
    "data-name": "Path 7671",
    d: "M43,25.458l3.58,15.725a.753.753,0,0,1-.627.912l-11.143,1.6a.753.753,0,0,1-.841-.578l-3.58-15.725a.752.752,0,0,1,.627-.911l11.143-1.6a.753.753,0,0,1,.841.578",
    transform: "translate(-30.369 -7.982)",
    fill: "#57c6f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7672",
    "data-name": "Path 7672",
    d: "M42.712,26.482,46.14,41.537,35.076,43.126,31.649,28.071Z",
    transform: "translate(-30.78 -8.499)",
    fill: "#e5f8ff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    y1: 1.35,
    x2: 9.402,
    transform: "translate(2.041 19.331)",
    fill: "none",
    stroke: "#a1d2f0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.574
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    y1: 1.35,
    x2: 9.402,
    transform: "translate(2.357 20.754)",
    fill: "none",
    stroke: "#a1d2f0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.574
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    y1: 0.843,
    x2: 5.875,
    transform: "translate(6.271 22.441)",
    fill: "none",
    stroke: "#a1d2f0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.574
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10",
    "data-name": "Line 10",
    y1: 0.843,
    x2: 5.875,
    transform: "translate(6.689 23.664)",
    fill: "none",
    stroke: "#a1d2f0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.574
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11",
    "data-name": "Line 11",
    y1: 0.844,
    x2: 5.875,
    transform: "translate(7.107 24.886)",
    fill: "none",
    stroke: "#a1d2f0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.574
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_12",
    "data-name": "Line 12",
    y1: 0.843,
    x2: 5.875,
    transform: "translate(4.952 31.646)",
    fill: "none",
    stroke: "#a1d2f0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.574
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7673",
    "data-name": "Path 7673",
    d: "M29.369,45.82a4.875,4.875,0,0,1-1.549-1.382l-1.328-1.581a1.315,1.315,0,0,1-.377-.706c.742-.06,1.22.9,1.963.961a15.508,15.508,0,0,0-1.475-3.5,1.078,1.078,0,0,1-.213-.873,5.661,5.661,0,0,1,2.062,1.506,11.009,11.009,0,0,1,1.118,1.421,15.306,15.306,0,0,1,2,4.912",
    transform: "translate(-12.452 -12.432)",
    fill: "#f2a181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7674",
    "data-name": "Path 7674",
    d: "M9.338,64.647l7.956-6.713S21,62.956,19.6,67.8a44.526,44.526,0,0,1-1.921,4.694c-.349,1.056-2.744,16.005-2.565,17.1s1.464,4.151,1.955,7.367c.59,3.868.49,16.47.947,19.811s-2.627,3.907-2.8,2.776C13.771,109.885,9.941,94.829,9.4,90s-.318-13.676-.067-25.352",
    transform: "translate(10.773 -18.592)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7675",
    "data-name": "Path 7675",
    d: "M19.832,81.835l3.46,7.94A17.78,17.78,0,0,0,20.878,98.1c-.058,1.532.077,3.066.035,4.6a1.559,1.559,0,0,1-.047.333c-.464-2.272-.809-4.143-.945-5.363a145.672,145.672,0,0,1-.261-15.839,1.444,1.444,0,0,1,.171.008",
    transform: "translate(0.257 -26.26)",
    fill: "#f2a181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7676",
    "data-name": "Path 7676",
    d: "M13.345,143.75s.741,3.505.541,3.952a6.14,6.14,0,0,1-1.65,2.215c-.77.493-2.476,1.078-2.612,1.292a.53.53,0,0,0,.1.716,3.535,3.535,0,0,0,2.432.617c2.313-.382,2.552-1.405,3.9-1.569.233-.028.664.316,1.307-.014a1.53,1.53,0,0,0,.9-1.484A6.635,6.635,0,0,0,17.237,147a20.149,20.149,0,0,1-.658-3.983",
    transform: "translate(12.114 -45.898)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7677",
    "data-name": "Path 7677",
    d: "M9.171,154.244c-.168-.289-.211-.725-.054-.832a13.546,13.546,0,0,1,1.44-.866c.448-.206,1.16-.388.909-.253s.211.641.63.615c1.45-.088,2.519-1.052,3.345-1.258a2.836,2.836,0,0,0,1.743-1.933,5.55,5.55,0,0,1,.856,1.632,2.852,2.852,0,0,1,.177,1.246,2.9,2.9,0,0,0-.132,1.188,2.274,2.274,0,0,1-.857.309,3.377,3.377,0,0,1-.922.014l-.1-.748a3.374,3.374,0,0,0-.737.073,4,4,0,0,0-1.127.526c-.165.2-.3.558-.517.668a4.614,4.614,0,0,1-1.9.474c-1.554.091-2.462-.361-2.75-.854",
    transform: "translate(12.484 -48.048)",
    fill: "#1b227a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7678",
    "data-name": "Path 7678",
    d: "M13.175,124.276c.172-.189,2.015-.489,2.879-.85a4.973,4.973,0,0,0,2.015-1.92,20.717,20.717,0,0,0,.125-3.847c-.172-6.88-1.443-23.692-1.628-27.719-.319-7,.589-14.221,3.281-25.455l10.026-7.695S32.681,62.011,31.741,67c-.545,2.9-2.947,3.341-3.353,4.466s-6.472,19.27-6.472,19.27a34.143,34.143,0,0,1,1.249,8.22c.058,3.668-1.605,14.735-1.914,18.95a13.821,13.821,0,0,0,.065,3.424c.3.769,1.055,1.673,1.017,2.643a1.492,1.492,0,0,1-1.139,1.32c-.711.221-1.107-.19-1.351-.2-1.413-.058-1.8.913-4.246.913A3.862,3.862,0,0,1,13.175,125a.516.516,0,0,1,0-.724",
    transform: "translate(-3.928 -18.226)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7679",
    "data-name": "Path 7679",
    d: "M26.848,155.941c-.133-.313-.115-.751.061-.831a14,14,0,0,1,1.608-.621c.492-.13,1.252-.194.974-.1s.126.669.564.712c1.508.149,2.748-.628,3.628-.7a2.314,2.314,0,0,0,1.825-1.626,5.827,5.827,0,0,1,.9,1.754,2.748,2.748,0,0,1,.006,1.261,2.757,2.757,0,0,0-.3,1.153,2.41,2.41,0,0,1-.928.165,3.678,3.678,0,0,1-.953-.138v-.756a3.67,3.67,0,0,0-.771-.049,2.556,2.556,0,0,0-1.244.44c-.206.155-.424.418-.67.48a5.115,5.115,0,0,1-1.98.149c-1.617-.164-2.489-.759-2.716-1.294",
    transform: "translate(-17.81 -49.029)",
    fill: "#1b227a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7680",
    "data-name": "Path 7680",
    d: "M23.894,56.333c.68.747,3.105,4.788,3.131,8.077a15.179,15.179,0,0,1-1.25,6.084C25.156,72.291,24,73.9,24,74.228s-1.808.556-5.643.314c-7.087-.446-9.69-1.776-9.69-1.776a55.5,55.5,0,0,1,.5-9.343c.345-3.038,2.932-7.847,2.932-7.847",
    transform: "translate(3.964 -17.836)",
    fill: "#466eb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7681",
    "data-name": "Path 7681",
    d: "M17.437,37.073S16.3,42.744,16,43.753s-1.78,7.417-3.184,7.306-9.09-6.529-9.09-6.529l1.089-2.177,6.766,3.225a87.059,87.059,0,0,1,1.148-9.069",
    transform: "translate(16.886 -11.717)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7682",
    "data-name": "Path 7682",
    d: "M14.982,42.481c-.716,2.532-2.184,5.2-2.623,7.163-.088.395-4.773-1.309-4.783-3.069",
    transform: "translate(16.726 -13.633)",
    fill: "#f2a181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7683",
    "data-name": "Path 7683",
    d: "M4.584,25.765a8.312,8.312,0,0,1,3.381,1.11c2.9,2.219.656,10.276.656,10.276s.143.431-1.8.321a14.017,14.017,0,0,1-3.509-.663l.562-6.6",
    transform: "translate(25.156 -8.269)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7684",
    "data-name": "Path 7684",
    d: "M8.843,32.482s.246,4.737-.611,7.126A7.7,7.7,0,0,1,6.643,39.4Z",
    transform: "translate(23.465 -10.424)",
    fill: "#b03d44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7685",
    "data-name": "Path 7685",
    d: "M12.459,3.663c-1.352,1.753-1.084,4.218-.751,6.406q.253,1.659.506,3.319a2.222,2.222,0,0,0,.6,1.439,2.22,2.22,0,0,0,1.539.314l-.016,2.747q2.35.057,4.7.019a4.534,4.534,0,0,1,.407-1.865c.767-.015,1.279-.784,1.579-1.489a21.654,21.654,0,0,0,.841-2.513,13.87,13.87,0,0,0,.664-3.447,4.985,4.985,0,0,0-.994-3.3,6,6,0,0,0-1.91-1.427A3.73,3.73,0,0,0,16.479,3.4",
    transform: "translate(6.558 -1.031)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7686",
    "data-name": "Path 7686",
    d: "M9.783,10.982a2.859,2.859,0,0,0-.13-2.053,1.348,1.348,0,0,0-.412-.522A.871.871,0,0,0,8.4,8.321a.933.933,0,0,0-.421.393A12.011,12.011,0,0,1,7.69,4.875,4.992,4.992,0,0,1,10.856.528c3.319-1.364,8.087-.016,9.435,3.241a8.061,8.061,0,0,1-1.446,8.074c-1.726,1.826-4.208,2.094-6.5,1.718-1.172-.192-2.98-.077-3.587-1.671a.178.178,0,0,1,.183-.236c.476.037.807-.5.841-.672",
    transform: "translate(10.855 0)",
    fill: "#1b227a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7687",
    "data-name": "Path 7687",
    d: "M22.048,6.962c-.124.194-.094.453-.21.651a1.529,1.529,0,0,1-.8.614c-.563.261-.431,1.081-.415,1.448-.425-.282-.494-1.051-.6-1.442-.115-.439-.189-.889-.316-1.324a6.72,6.72,0,0,1-.38-1.268,5.207,5.207,0,0,1,1.994-4.211,2.774,2.774,0,0,1,3.106.037A2.426,2.426,0,0,1,25.315,2.6a.747.747,0,0,1,.035.605",
    transform: "translate(-1.665 -0.312)",
    fill: "#1b227a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7688",
    "data-name": "Path 7688",
    d: "M22.592,25c-.079-.536-.225-1.162-.724-1.374a1.59,1.59,0,0,0-.441-.094,36.473,36.473,0,0,0-4.6-.217,4.276,4.276,0,0,0-1.863.327,4.584,4.584,0,0,0-1.815,2.308",
    transform: "translate(5.333 -7.48)",
    fill: "#b03d44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7689",
    "data-name": "Path 7689",
    d: "M6.986,45.087a12.819,12.819,0,0,0,.884-1.042A16.348,16.348,0,0,0,8.52,38.8c-.156-.962-1.008-1.48-1.393-3.622A7.922,7.922,0,0,1,8.4,29.351c.894-1.3.364-1.292.67-2.883a1.521,1.521,0,0,1,.316-.792,7.616,7.616,0,0,1,1.788-.847,28.188,28.188,0,0,1,6.459.025,21.528,21.528,0,0,1,3.705.469c1.351.3,2.527.656,2.8,2.489a18.459,18.459,0,0,1-.793,8.39c-.571,1.782-3.982,7.947-3.137,9.14a4.079,4.079,0,0,1,.735,1.131c.214,1.246-2.6,1.684-3.806,1.783a47.09,47.09,0,0,1-5.783-.037c-1.394-.065-4.444-.552-4.661-2.275a1.243,1.243,0,0,1,.292-.858",
    transform: "translate(7.991 -7.907)",
    fill: "#f47458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7690",
    "data-name": "Path 7690",
    d: "M25.472,39.382a4.963,4.963,0,0,0,.37,1.438,3.857,3.857,0,0,0,2.533.115,36.776,36.776,0,0,1,1.144-4.845s-4.047,2.829-4.047,3.293",
    transform: "translate(-9.965 -11.582)",
    fill: "#b03d44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7691",
    "data-name": "Path 7691",
    d: "M40.4,37.384s-4.591,11.1-6.584,11.1c-1.448,0-5-10.243-5-10.243l2.245-1.063,2.5,4.29,2.535-8",
    transform: "translate(-23.108 -10.739)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7692",
    "data-name": "Path 7692",
    d: "M47,37.04a4.373,4.373,0,0,1-.69-2,8.5,8.5,0,0,0,.052-2.122,8.834,8.834,0,0,0-.751-1.456c-.215-.189-1.013-.492-1.208-.357s-.438-.486-.761-.432a.686.686,0,0,0-.593.621c0,.3-.432.35-.486.566a3,3,0,0,1-.108.566c-.081.162-.319.082-.4.486-.078.369.026.4,0,.593s-.189.171-.135.53a4.5,4.5,0,0,0,.516,1.23,3.554,3.554,0,0,0,1.252,1.268,2.386,2.386,0,0,1,.731,1.008",
    transform: "translate(-38.61 -9.842)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7693",
    "data-name": "Path 7693",
    d: "M44.312,27.352a.275.275,0,0,1,.4-.107.354.354,0,0,1,.088.441l-1.357,3.072s-.11.126-.32-.059c-.228-.2-.155-.3-.155-.3s1.291-2.957,1.348-3.046",
    transform: "translate(-37.153 -8.727)",
    fill: "#1b227a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7694",
    "data-name": "Path 7694",
    d: "M44.168,31.6a3.134,3.134,0,0,0,.828.862c.211.2.185.327.418.531-.408-.031-.338-.272-.868-.653A1.121,1.121,0,0,1,44,31.672a.093.093,0,0,1,.169-.071",
    transform: "translate(-38.439 -10.127)",
    fill: "#f2a181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7695",
    "data-name": "Path 7695",
    d: "M32.4,24.646c-1.2.063-4.677-.549-6.611,1.476-1.621,1.695-2.549,6.139-3.2,7.941,1.624,1.654,3.188,2.989,5.647,2.452.093-.07,1.313-3.911,2.2-4.252",
    transform: "translate(-10.893 -7.897)",
    fill: "#f47458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7696",
    "data-name": "Path 7696",
    d: "M11.136,74.495s-.79,18.983-.646,20.367,1.684,27.593,1.684,27.593a14.288,14.288,0,0,0,5.056,0s2.443-20.41,0-26.77l1.086-6.094s-.162,4.533,0,5.456,5.05,26.762,5.05,26.762,3.233-.086,4.71-1.381c0,0,.46-17.952-2.908-25.5L28.251,75.17l-1.776-5.027Z",
    transform: "translate(1.488 -22.511)",
    fill: "#466eb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7697",
    "data-name": "Path 7697",
    d: "M15.187,90.874c.452-2.919,3.237-13.275,3.356-13.524,1.523-1.18,2.915-2.221,3.421-3.2-.833,2.5-2.435,2.626-3.034,3.918-1.482,3.19-.35,2.487-3.808,13.176",
    transform: "translate(4.618 -23.795)",
    fill: "#170d54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7698",
    "data-name": "Path 7698",
    d: "M7.965,22.164c.071,1.01-.135,2.019-.151,3.031a3.671,3.671,0,0,0,.945,2.792,1.8,1.8,0,0,0,2.652-.149,4,4,0,0,1-2.9,2.089,6.143,6.143,0,0,1-3.614-.557A8.455,8.455,0,0,1,0,21.568c.076-2.71,2.134-5.329,5.009-3.9a5.535,5.535,0,0,1,2.953,4.5",
    transform: "translate(25.442 -5.54)",
    fill: "#1b227a"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71959",
    "data-name": "Group 71959",
    transform: "translate(-20086.719 4832.23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71956",
    "data-name": "Group 71956",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7980",
    "data-name": "Path 7980",
    d: "M323.7,958.636a5.915,5.915,0,0,1-3.007,2.277c-1.755.4-3.484,1.048-3.5,2.156s5.075,1.768,7.084.651c3-1.667,3.3-1.164,3.635-2s-.4-3.061-.378-3.326c.027-.327-3.837.24-3.837.24",
    transform: "translate(-306.151 -848.355)",
    fill: "#353a3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7981",
    "data-name": "Path 7981",
    d: "M321.418,949.021a7.98,7.98,0,0,0-.194.924c.034.019,3.955.486,3.837-.239-.1-.589-.233-1.228-.233-1.228Z",
    transform: "translate(-303.674 -839.663)",
    fill: "#81807e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7982",
    "data-name": "Path 7982",
    d: "M107.991,956.6a5.512,5.512,0,0,1-2.418,2.4c-1.63.652-2.938,1.4-2.908,2.481s3.985,2.173,6.863.1c1.818-1.309,2.394-1.315,2.686-2.14s-.507-2.966-.5-3.224c.013-.32-3.728.38-3.728.38",
    transform: "translate(-65.815 -846.448)",
    fill: "#353a3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7983",
    "data-name": "Path 7983",
    d: "M107.528,946.708a8.759,8.759,0,0,0,.045.93c.034.018,3.824.33,3.728-.38a5.842,5.842,0,0,0-.368-1.246Z",
    transform: "translate(-65.397 -837.481)",
    fill: "#81807e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7984",
    "data-name": "Path 7984",
    d: "M106.506,443.1s-4.978,19.072-6.874,23.481c-1.756,4.085-2.336,9.8-2.578,12.667-.3,3.609-2.114,17.663-2.327,18.718s5.856.584,5.856.584,4.185-24.3,5.922-27.846c1.159-2.366,7.887-19.337,8.656-18.36s1.724,17.981,2.294,20.8,2.32,25.126,2.32,25.126,3.913.577,4.958-.307c0,0,.476-19.044.113-24.336-.138-2.017,2.363-24.181-.844-33.1-1.7-4.716-17.5,2.574-17.5,2.574",
    transform: "translate(-78.272 -388.582)",
    fill: "#ea7064"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7985",
    "data-name": "Path 7985",
    d: "M67.956,182.987a11.554,11.554,0,0,1-1.069,2.346c-.961-1.923-1.717-3.5-1.964-4.083-.81-1.914-4.985-6.3-4.985-6.3a.036.036,0,0,1,0,.009.018.018,0,0,1,0,.006.011.011,0,0,0,0,0c0,.006,0,.012,0,.018s-.006.023-.01.037a.22.22,0,0,0-.006.023.158.158,0,0,0,0,.018,51.462,51.462,0,0,0-1.675,8.748c-.057,2.838-.8,8.09-.8,8.09h0l-.872.122-1.929.272-.231.032-.561.079-5.115.72-1.814.255-.245.035-1.037.146-2.864.4-.73.1h-.007l-.547.077-.756.106h0a5.119,5.119,0,0,1-.625-3.18c.07-1.4.239-4.04.169-6.485,0-.013,0-.026,0-.038,0-.031,0-.062,0-.093,0-.011,0-.021,0-.031v-.006a17.464,17.464,0,0,0-.414-3.585,14.865,14.865,0,0,1-.356-1.911l-.011-.088c-.013-.113-.025-.225-.035-.334a16.85,16.85,0,0,1-.027-3.064l0,.006c-.052.113-.425,1.481-.914,3.17-.827,2.855-1.985,6.629-2.479,6.81-.717.264-12.339,3.706-14.849,4.059-.29.041-.459.04-.475-.011s-.023-.074-.035-.113c-.3-1.005-.724-2.714-.791-2.99-.007-.025-.01-.039-.01-.039l.45-.135,12.645-3.789,5.781-16.67c.121-.1,1.54-.784,2.577-1.277,1.057-.5,2.332-1.243,3.486-1.875.589-.322,1.146-.616,1.627-.837l.074-.034h0l1.325-.605h0l.346-.033c1.11-.106,4.561-.429,5.717-.5.1-.006.175-.01.237-.011s.092,0,.117,0a14.429,14.429,0,0,1,1.792.613h0l.107.041.132.05.247.1.514.2.182.072a36.79,36.79,0,0,1,4.523,2.026,27.756,27.756,0,0,1,2.6,4.659c1.565,5.013,3.548,12.686,3.61,14.578,0,.03,0,.059,0,.085",
    transform: "translate(-11.994 -142.145)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7986",
    "data-name": "Path 7986",
    d: "M109.5,436.073a4.748,4.748,0,0,0-.5,2.41s15.824-1.846,17.5-2.574c0,0,.065-2.148-.289-2.186-.39-.041-16.712,2.349-16.712,2.349",
    transform: "translate(-80.771 -383.965)",
    fill: "#495055"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7987",
    "data-name": "Path 7987",
    d: "M146.072,112.161c-.049,2.484-4.858,3.842-4.858,3.842s-2.011-2.522-1.531-2.763c.189-.095.265-.471.289-.893a8.726,8.726,0,0,0-.027-1.126c-.014-.176-.028-.289-.028-.289s.687-.725,1.561-1.589c1.527-1.51,3.627-3.445,3.63-2.675a.671.671,0,0,1-.018.146c-.369,1.732.981,5.347.981,5.347",
    transform: "translate(-103.847 -94.276)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7988",
    "data-name": "Path 7988",
    d: "M133.433,436.347s.345,2.178.375,2.746l.732-.146s-.2-2.3-.32-2.691Z",
    transform: "translate(-91.607 -386.207)",
    fill: "#353a3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7989",
    "data-name": "Path 7989",
    d: "M239.583,451.193s-.277,1.98-.284,2.727l.775-.1s.159-2.472.247-2.73Z",
    transform: "translate(-209.533 -399.338)",
    fill: "#353a3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7990",
    "data-name": "Path 7990",
    d: "M160.5,124.178h0c-.01.014-.213.32-.561.758A10.075,10.075,0,0,1,156.256,128a8.727,8.727,0,0,0-.028-1.126,2.521,2.521,0,0,1-.477-.057,14.8,14.8,0,0,1,1.046-1.531l.965-.289Z",
    transform: "translate(-120.131 -109.932)",
    fill: "#a77860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7991",
    "data-name": "Path 7991",
    d: "M142.351,43.9c-.416.9-.811,1.561-.923,1.821h0a3.217,3.217,0,0,1-.561.758,5.544,5.544,0,0,1-3.714,1.94,2.51,2.51,0,0,1-.477-.057,2.272,2.272,0,0,1-1.655-1.143,13.006,13.006,0,0,1-.828-10.676s8.2-2.32,9.486.15c.9,1.732-.35,5.082-1.327,7.209",
    transform: "translate(-101.055 -31.479)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7992",
    "data-name": "Path 7992",
    d: "M123.723,5.068s-.762-.042-.95-1.486c-.186-1.427.19-1.822.19-1.822a33.9,33.9,0,0,1,4.6-1.6c1.216-.184,4.206-.361,4.907.44,0,0,1.7-.4,2.167,2.431.736,4.485-2.508,8.84-2.508,8.84s.028-2.93-.618-3.318-1.2.535-1.2.535l-1.322.237s2.008-4.335-.4-4.5-3.485.493-4.864.241",
    transform: "translate(-90.585 0)",
    fill: "#252e3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7993",
    "data-name": "Path 7993",
    d: "M140.995,59.467c.126-1.291,2.46-1.784,2.3-.431s-1.306,2.653-1.837,2.607-.563-1.193-.467-2.176",
    transform: "translate(-101.236 -51.55)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7994",
    "data-name": "Path 7994",
    d: "M37.06,190.068c-1.017,1.94-2.621,4.794-4.206,7.562.209.389.412.775.608,1.157a23.174,23.174,0,0,1,1.2,2.675c.361,1.011.863,3.6-.1,4.084L29.5,208.34s-.035-.1-.1-.282c-.168-.455-.531-1.427-1.035-2.687-.017-.041-.067-.161-.142-.338-.1-.237-.246-.577-.412-.964l-.234-.544c-.091-.215-.187-.436-.281-.656l-.4-.935c-.345-.8-.615-1.43-.615-1.43l-.051-.111q-.247-.534-.506-1.07c-.266-.552-.54-1.1-.82-1.639-.028-.055-.056-.109-.085-.163l-.15-.282-.093-.171-.021-.038-.038-.068c-1.464-2.67-3.112-4.9-3.638-8.175q-.076-.474-.145-.942c-.076-.52-.146-1.033-.21-1.536-.024-.19-.048-.378-.07-.565-.264-2.184-.421-4.13-.548-5.485-.4-4.223,2.191-8.8,4.176-11.619a31.277,31.277,0,0,1,2.123-2.713l.01-.01.107.041.132.05.247.1.514.2.182.072c1.923.754,5.972,1.868,6.482,2.233a20.443,20.443,0,0,1,1.711,4.571,73.111,73.111,0,0,1,2.539,14.458c0,.03,0,.059,0,.085a11.552,11.552,0,0,1-1.069,2.346m-7.692-.943a8.735,8.735,0,0,0,.777,3.17l.036.087c.325-.692.63-1.356.9-1.97a.008.008,0,0,0,0,0,15.832,15.832,0,0,0,1.3-3.522c.186-3.343-2.277-7.192-2.277-7.192a.02.02,0,0,1,0,.006.01.01,0,0,0,0,0c0,.006,0,.012,0,.018s-.007.024-.01.037a.23.23,0,0,0-.006.023.164.164,0,0,0,0,.018c-.5,1.988-.713,9.324-.713,9.324",
    transform: "translate(17.833 -146.88)",
    fill: "#323657"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7995",
    "data-name": "Path 7995",
    d: "M1.093,386.655l16.42,6.953a1.879,1.879,0,0,0,2.431-.888l4.5-9.608A1.719,1.719,0,0,0,23.5,380.8l-16.42-6.953a1.879,1.879,0,0,0-2.43.888l-4.5,9.608a1.719,1.719,0,0,0,.933,2.312",
    transform: "translate(36.626 -332.354)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8012",
    "data-name": "Path 8012",
    d: "M1.093,386.655l16.42,6.953a1.879,1.879,0,0,0,2.431-.888l4.5-9.608A1.719,1.719,0,0,0,23.5,380.8l-16.42-6.953a1.879,1.879,0,0,0-2.43.888l-4.5,9.608a1.719,1.719,0,0,0,.933,2.312",
    transform: "translate(36.336 -332.907)",
    fill: "#140000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7996",
    "data-name": "Path 7996",
    d: "M233.474,170.895a67.619,67.619,0,0,0-1.552,7.876,0,0,0,0,1,0,0c-.03.189-.059.381-.089.578,0,.023-.007.046-.01.068-.02.13-.04.262-.059.4l-.007.047c-.013.09-.027.18-.04.271q-.049.333-.1.679c-.39,2.737-.938,7.4-1.465,12.1v0c-.416,3.707-1.364,7.51-1.665,10.349,0,0,0,0,0,.006a19.565,19.565,0,0,1-.394,2.134c-.021.095-.044.19-.066.287-.848,3.583-2.494,8.654-2.494,8.654l-.48-.443-1.42-1.311a1.151,1.151,0,0,1-.319-1.188c.788-2.541,3.464-11.533,3.955-17.855a.02.02,0,0,0,0-.006c-.241-2.222-.856-5.2-.764-5.631-.006.015-.012.031-.017.046-.282.784-.594,1.636-.909,2.466h0c-.845,2.228-1.709,4.292-2.069,4.424-.8.295-15.188,4.539-15.292,3.947-.01-.06-.023-.123-.037-.19s-.027-.136-.043-.208c-.178-.811-.5-1.973-.725-2.758l-.093-.321c-.095-.325-.156-.531-.156-.531l12.167-3.993,6.139-16.054c.121-.1,1.687-.939,2.724-1.432,1.08-.514,2.446-1.148,3.658-1.708.579-.268,1.124-.518,1.585-.73Z",
    transform: "translate(-198.999 -151.263)",
    fill: "#323657"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7997",
    "data-name": "Path 7997",
    d: "M120.022,172.076l-2.339,1.319,1,1.019-2.661,14.369c-.543-3.368-.79-6.566-.973-8.528-.612-6.528,5.9-13.892,6.309-14.343.313.119.651.25,1,.388Z",
    transform: "translate(-77.31 -146.878)",
    fill: "#020717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7998",
    "data-name": "Path 7998",
    d: "M210.752,170.574a75.7,75.7,0,0,0-1.893,9.98c-.391,2.737-.939,7.4-1.465,12.1l-.544-13.457,1.114-1.207-.991-1.238,2.12-5.413c.579-.268,1.124-.518,1.585-.73Z",
    transform: "translate(-176.241 -151.005)",
    fill: "#020717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7999",
    "data-name": "Path 7999",
    d: "M129.4,157.095l-1.953-1.2s-.054,1.064-4.858,3.842l1.364,3.842Z",
    transform: "translate(-85.22 -138.011)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8000",
    "data-name": "Path 8000",
    d: "M183.53,160.568a9.04,9.04,0,0,0,1.278,3.306l-2.662,3.471-.194-5.629Z",
    transform: "translate(-147.44 -142.147)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8001",
    "data-name": "Path 8001",
    d: "M180.279,189.386a9.06,9.06,0,0,1,.33,2.642,2.519,2.519,0,0,1-1.95-.1,9.067,9.067,0,0,1,1.62-2.538",
    transform: "translate(-142.904 -167.659)",
    fill: "#1a2b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8002",
    "data-name": "Path 8002",
    d: "M203.133,402.494a39.09,39.09,0,0,1,0-6l.247.016a39.959,39.959,0,0,0,0,5.94Z",
    transform: "translate(-168.426 -351.003)",
    fill: "#ad9f99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8003",
    "data-name": "Path 8003",
    d: "M190.177,442.976s-2.328.278-3.1.47l.1,2.61,3.049-.325Z",
    transform: "translate(-153.45 -392.156)",
    fill: "#69737a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8004",
    "data-name": "Path 8004",
    d: "M182.915,207.664a36.641,36.641,0,0,0-2.173,13.9c.439,7.611,1.16,10.371,1.16,10.371l1.6,2.008.706-2.468a60.545,60.545,0,0,1-.762-19.145c.251-1.711.625-4.953.625-4.953Z",
    transform: "translate(-146.697 -183.584)",
    fill: "#1a2b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8005",
    "data-name": "Path 8005",
    d: "M104.37,479.785s-.557,1.115-1.114,1.3a4.826,4.826,0,0,0-1.37,1.091l3.924,2.066A10.744,10.744,0,0,0,106.9,480.9c.046-1.3-2.531-1.115-2.531-1.115",
    transform: "translate(-60.349 -424.734)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8006",
    "data-name": "Path 8006",
    d: "M100.137,480.767l-.26.522a17.964,17.964,0,0,0,3.164,1.939l.23-.7Z",
    transform: "translate(-56.488 -425.611)",
    fill: "#decbc4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8007",
    "data-name": "Path 8007",
    d: "M38.019,384a19.123,19.123,0,0,0,3.441,2.256L48.51,373.9l-4.5-2.46S38.143,383.074,38.019,384",
    transform: "translate(5.37 -328.824)",
    fill: "#323657"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8008",
    "data-name": "Path 8008",
    d: "M263.044,256.651c-.087,1.761-.074,3.325-.074,3.325h0c0,.008,0,.056-.006.135l-.011-.088c-.282.784-.594,1.636-.909,2.466a26.4,26.4,0,0,1-.071-2.687,16.482,16.482,0,0,1,1.679-7.528,16.769,16.769,0,0,0-.609,4.376",
    transform: "translate(-235.465 -223.332)",
    fill: "#2d3133"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_71959-2",
    "data-name": "Group 71959",
    transform: "translate(1.857 41.764) rotate(-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8009",
    "data-name": "Path 8009",
    d: "M5.774,1.61S4.433.432,4.222.258A4.3,4.3,0,0,0,2.377,0,5,5,0,0,0,.225.5.765.765,0,0,0,0,1.1a1.475,1.475,0,0,0,.222.714A.9.9,0,0,0,.3,2.672a.781.781,0,0,0,.224.84.654.654,0,0,0,.152.705A5.921,5.921,0,0,1,1.709,4.4a12.461,12.461,0,0,0,3.4-.028s1.7-.14.67-2.764",
    transform: "translate(0.051 2.402)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8010",
    "data-name": "Path 8010",
    d: "M.506,0S2.73.08,2.761.44a.566.566,0,0,1-.175.511l.9.448s.429.633-.386.915c0,0,.462.55-.357.728,0,0,.143.5-.222.648a7.42,7.42,0,0,1-1.793.04S.336,3.6.476,3.051A.827.827,0,0,1,.307,2.2a.856.856,0,0,1-.082-.869S-.314.551.276.007c0,0,.136-.01.23-.006",
    transform: "translate(0 2.89)",
    fill: "#db9c7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8011",
    "data-name": "Path 8011",
    d: "M.274,3.308A14.844,14.844,0,0,1,.022.337C.048.133.041.056.24,0S.771.659.992,1.284a6.435,6.435,0,0,0,.81,1.4s.019.644-1.527.63",
    transform: "translate(2.494 0)",
    fill: "#eea886"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoImageEn);
export default __webpack_public_path__ + "static/media/info_image_en.3b0f9dae4e7723ee637311335a0e3eb4.svg";
export { ForwardRef as ReactComponent };